/* tslint:disable */
/* eslint-disable */

export interface AcessoResidenteModel {
    captcha: string;
    cpf: string;
}

export interface AcessoSupervisorModel {
    captcha: string;
    cpf: string;
}

export interface AdesaoCursoModel {
    dataAdesao: Date;
    matriculaId: number;
    termoInteresse: ArquivoModel;
}

export interface AdicaoResidenteModel {
    programaId: string;
    residentes: ResidenteTableItemModel[];
}

export interface AgenciaModel {
    codigoAgencia: string;
    codigoBanco: string;
    nomeAgencia: string;
}

export interface AnexoParecerTransferenciaModel {
    anexoParecerCNRMTransferencia: ArquivoAnexoModel;
    transferenciaId: number;
}

export interface AnoAdicionalDomainModel {
    area: string;
    descricao: string;
    duracao: string;
    duracaoNumerica: number;
    grandeArea: string;
    id: number;
    subArea: string;
}

export interface AnoAdicionalModel {
    descricao: string;
    duracao: string;
    id: number;
}

export interface AnoResidenciaCategoriaModel {
    anoResidenciaEnum: AnoResidenciaDomainModel;
    categoriaProfissionalList: CategoriaProfissionalDomainModel[];
}

export interface AnoResidenciaDomainModel {
    descricao: string;
    id: number;
}

export interface AnuenciaTransferenciaModel {
    anexoCopiaDecisaoJudicial: ArquivoAnexoModel;
    anexoOficioComissaoDestino: ArquivoAnexoModel;
    anexoOficioComissaoOrigem: ArquivoAnexoModel;
    anexoParecerCNRMDescredenciamento: ArquivoAnexoModel;
    anexoParecerComissaoDestino: ArquivoAnexoModel;
    anexoTermoAnuencia: ArquivoAnexoModel;
    confirmada: boolean;
    devolverParaSubstituicao: boolean;
    parecer: string;
    transferenciaId: number;
}

export interface AreaAtuacaoDomainModel {
    area: string;
    descricao: string;
    duracao: string;
    duracaoNumerica: number;
    grandeArea: string;
    id: number;
    subArea: string;
}

export interface AreaAtuacaoModel {
    descricao: string;
    duracao: string;
    id: number;
}

export interface AreaConcentracaoDomainModel {
    descricao: string;
    duracao: string;
    duracaoNumerica: number;
    id: number;
}

export interface AreaConcentracaoModel {
    descricao: string;
    duracao: string;
    id: number;
}

export interface AreaDomainModel {
    descricao: string;
    id: number;
}

export interface ArquivoAnexoModel extends ChildIDMapperModel {
    anexoId: number;
    arquivo: ArquivoModel;
    arquivoParecer: string;
    arquivoValido: boolean;
    dsAnexo: string;
    extensoesValidas: string;
    obrigatorio: boolean;
    tamanhoMaximo: number;
}

export interface ArquivoModel {
    ativo: boolean;
    dataCriacao: Date;
    hash: string;
    id: number;
    nome: string;
    tamanho: number;
    temporario: boolean;
}

export interface ArquivosRodapeModel {
    faq: ArquivoModel;
    manual: ArquivoModel;
    modeloInstituicao: ArquivoModel[];
}

export interface ArquivosTermosCompromissoModel {
    termoResidenciaAreaProfissional: ArquivoModel;
    termoResidenciaMedica: ArquivoModel;
}

export interface AuxilioMoradiaItemModel extends ResidenteItemModel {
    dataAtualizacao: Date;
    dataAvaliacao: string;
    dataDesistencia: string;
    dataReavaliacao: string;
    dataRecurso: string;
    dataSolicitacao: string;
    dataSuspensao: string;
    dsMotivoDesistencia: string;
    dsMotivoSuspensao: string;
    situacaoAuxilioMoradia: number;
}

export interface AuxilioMoradiaModel {
    dataAtualizacao: Date;
    dataAvaliacao: string;
    dataDesistencia: string;
    dataReavaliacao: string;
    dataRecurso: string;
    dataSolicitacao: string;
    dataSuspensao: string;
    dsMotivoDesistencia: string;
    dsMotivoSuspensao: string;
    id: number;
    residente: ResidenteModel;
    situacao: SituacaoAuxilioMoradiaDomainModel;
}

export interface AvaliacaoContestacaoModel {
    contestacaoId: number;
    declaracaoDiasAprovados: boolean;
    documentoComprobatorio: ArquivoAnexoModel;
    parecerAvaliacao: string;
    resultadoContestacao: boolean;
}

export interface AvaliacaoListFilterModel {
    areas: number[];
    cnpj: string;
    codigoMS: number;
    editalID: number;
    isNovoPrograma: boolean;
    protocoloCNRM: string;
    regiao: string;
    situacoesInscricao: number[];
    tipoPrograma: number;
    uf: string;
}

export interface AvaliacaoListPayloadModel {
    inscricoes: InscricaoTableItemModel[];
    pageInfo: PageInfoModel;
}

export interface AvaliacaoProgramaModel {
    areaConcentracao: AreaConcentracaoDomainModel;
    avaliador: DadosPessoaisModel;
    distribuicaoBolsas: DistribuicaoBolsaModel[];
    documentosAnexos: ArquivoAnexoModel[];
    dsDuracao: string;
    dsTitulo: string;
    hasDivergenciasMec: boolean;
    idComissao: number;
    idPrograma: number;
    idRecursoPrograma: number;
    instituicao: InformacoesInstitucionaisModel;
    modalidadePrograma: ModalidadeProgramaDomainModel;
    nbDuracao: number;
    nuBolsasAprovadas: number;
    nuBolsasAprovadasAvaliacao: number;
    nuBolsasSolicitadas: number;
    nuProtocoloCNRM: string;
    nuVagasAprovadasCNRM: number;
    parecer: string;
    periodoAvaliacao: PeriodoAvaliacaoDomainModel;
    periodoRecurso: PeriodoRecursoDomainModel;
    resultadoAvaliacao: ResultadoAvaliacaoDomainModel;
    secretariasConveniadas: ArquivoAnexoModel[];
    situacaoInscricao: SituacaoInscricaoDomainModel;
    tipoPrograma: string;
    tipoResidencia: TipoResidenciaDomainModel;
    tipoVaga: TipoVagaDomainModel;
}

export interface BancoDomainModel {
    descricao: string;
    id: string;
}

export interface CadastroComissaoInstituicaoModel {
    comissao: DadosComissaoModel;
    instituicao: DadosInstituicaoModel;
    pessoal: DadosPessoaisModel;
    senha: SenhaModel;
}

export interface CadastroModel {
    canCadastrar: boolean;
    dadosPessoais: DadosPessoaisModel;
    hasPapelCoordenador: boolean;
}

export interface CategoriaProfissionalDomainModel {
    conselhoProfissional: ConselhoProfissionalDomainModel;
    descricao: string;
    id: number;
}

export interface CategoriaProfissionalModel {
    descricao: string;
    id: number;
}

export interface ChildIDMapperModel {
    id: number;
    registroAtivo: boolean;
}

export interface ComissaoModel {
    contato: string;
    email: string;
    id: number;
    telefone: string;
    tipoComissao: TipoComissaoDomainModel;
}

export interface CompetenciaModel {
    anoCompetencia: number;
    dataCompetencia: string;
    dataFim: string;
    dataInicio: string;
    folhasProcessadas: boolean;
    id: number;
    nomeCompetencia: string;
    nomeMesCompetencia: string;
}

export interface CompetenciaTablePageModel {
    content: CompetenciaModel[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export interface ComunicadoModel {
    descricao: string;
    id: number;
    titulo: string;
}

export interface ConclusaoResidenciaLoteModel {
    dataConclusao: string;
    documentoComprobatorio: ArquivoAnexoModel;
    residentesSelecionados: ResidenteConclusaoResidenciaModel[];
}

export interface CondicaoContestacaoModel {
    hasFaltasParaCompensar: boolean;
    hasProgramaAtivo: boolean;
    isNotPeriodoAdaptacaoPagamento: boolean;
}

export interface ConselhoProfissionalDomainModel {
    abreviacao: string;
    descricao: string;
    id: number;
}

export interface ContatoModel {
    celular: string;
    email: string;
    telefone: string;
}

export interface ContestacaoListDegtsFilterModel {
    cnpj: string;
    cpf: string;
    protocolo: number;
    situacaoContestacao: number[];
    tipoResidencia: number;
}

export interface ContestacaoPagamentoModel {
    demonstrativoId: number;
    documentoComprobatorio: ArquivoAnexoModel;
    justificativaContestacao: string;
    nuDiasIncorretos: number;
    ocorrenciaId: number;
    tipoContestacao: TipoContestacaoDomainModel;
}

export interface ContestacaoResidenteModel {
    avaliador: string;
    cpf: string;
    dataCompetencia: string;
    dataContestacao: string;
    nomeInstituicao: string;
    nomeResidente: string;
    programa: string;
    protocolo: number;
    situacaoContestacao: SituacaoContestacaoDomainModel;
}

export interface CoordenadorModel {
    cpf: string;
}

export interface DadosBancariosModel {
    banco: BancoDomainModel;
    codigoAgencia: string;
    comprovanteAnexo: ArquivoModel;
    dadosConfirmados: boolean;
    digitoVerificadorConta: string;
    id: number;
    numeroConta: string;
    tipoConta: TipoContaDomainModel;
}

export interface DadosBancariosResidenteModel {
    contaCorrente: DadosBancariosModel;
    contaSalario: DadosBancariosModel;
}

export interface DadosComissaoEditModel {
    comissaoId: number;
    confirmarEmail: string;
    emailInstitucional: string;
    endereco: EnderecoModel;
    nomeContato: string;
    telefoneInstitucional: string;
    tipoComissaoId: number;
}

export interface DadosComissaoModel {
    confirmarEmail: string;
    contato: string;
    email: string;
    endereco: EnderecoModel;
    telefone: string;
}

export interface DadosComissaoVisualizeModel {
    cnpj: string;
    emailInstitucional: string;
    endereco: EnderecoModel;
    naturezaJuridica: string;
    nomeContato: string;
    nomeInstituicao: string;
    razaoSocial: string;
    telefoneInstitucional: string;
    tipoComissaoId: number;
}

export interface DadosComplementaresModel {
    contato: ContatoModel;
    endereco: EnderecoModel;
}

export interface DadosDemonstrativoModel {
    dataCompetencia: string;
    numeroCompensacoes: number;
    numeroFaltas: number;
    registroOcorrenciaList: RegistroOcorrenciaModel[];
    totalFaltasNaoCompensadas: number;
}

export interface DadosInscricaoModel {
    anoAdicional: AnoAdicionalModel;
    areaAtuacao: AreaAtuacaoDomainModel;
    areaConcentracao: AreaConcentracaoModel;
    avaliador: DadosPessoaisModel;
    especialidade: EspecialidadeDomainModel;
    idComissao: number;
    idRecursoPrograma: number;
    modalidadePrograma: ModalidadeProgramaDomainModel;
    nuBolsasAprovadas: number;
    nuBolsasAprovadasAvaliacao: number;
    nuBolsasSolicitadas: number;
    nuProtocoloCNRM: string;
    nuVagasAprovadasCNRM: number;
    parecerAvaliacao: string;
    rascunho: boolean;
    residenciaMedica: boolean;
    tipoPrograma: TipoProgramaDomainModel;
    tipoVaga: TipoVagaDomainModel;
}

export interface DadosInstituicaoModel {
    cnpj: string;
    pessoaJuridicaResumo: ResumoReceitaPessoaJuridicaModel;
    tipoComissao: TipoComissaoDomainModel;
}

export interface DadosPessoaisModel {
    celular: string;
    confirmarEmail: string;
    cpf: string;
    dataNascimento: string;
    email: string;
    endereco: EnderecoModel;
    idPessoa: number;
    nome: string;
}

export interface DadosPessoaisResidenteModel {
    cpf: string;
    dataEmissaoRG: string;
    dataNascimento: string;
    dataPrimeiroEmprego: string;
    escolaridade: EscolaridadeDomainModel;
    estadoCivil: EstadoCivilDomainModel;
    municipio: MunicipioModel;
    nacionalidade: NacionalidadeDomainModel;
    nome: string;
    nomeMae: string;
    numeroDependentes: number;
    orgaoEmissorRG: OrgaoEmissorRGDomainModel;
    pais: PaisModel;
    pis: string;
    racaCor: RacaCorDomainModel;
    rg: string;
    sexo: SexoDomainModel;
    tipoSanguineo: TipoSanguineoDomainModel;
    tituloEleitor: string;
    ufEmissoraRG: UFDomainModel;
    ufNaturalidade: UFDomainModel;
}

export interface DadosProfissionaisModel {
    conselhoProfissional: ConselhoProfissionalDomainModel;
    numeroInscricao: string;
}

export interface DadosResidenteModel {
    dadosPessoais: DadosPessoaisResidenteModel;
    dadosProfissionais: DadosProfissionaisModel;
}

export interface DemonstrativoModel {
    folha: FolhaModel;
    id: number;
    matriculado: MatriculadoModel;
    numeroCompensacoes: number;
    numeroFaltas: number;
    registros: ProcessamentoOcorrenciaModel[];
    situacaoPagamento: SituacaoPagamentoDomainModel;
    tipoPagamento: TipoPagamentoDomainModel;
    valorAditivos: number;
    valorBaseInss: number;
    valorBolsa: number;
    valorBonificacao: number;
    valorDescontoInss: number;
    valorDescontos: number;
    valorLiquido: number;
}

export interface DistribuicaoBolsaModel extends ChildIDMapperModel {
    categoria: CategoriaProfissionalDomainModel;
    qtdAprovada: number;
    qtdAprovadaAvaliacao: number;
    qtdAprovadaRecurso: number;
    qtdAprovadaTotal: number;
    qtdAtribuido: number;
    qtdMatriculados: number;
    qtdMatriculadosR1: number;
}

export interface DocumentoComprobatorioDomainModel {
    descricao: string;
    id: number;
}

export interface DocumentoTransferenciaDomainModel {
    descricao: string;
    id: number;
}

export interface DuracaoProgramaDomainModel {
    descricao: string;
    id: number;
}

export interface EditalComboModel {
    descricao: string;
    id: number;
    tipoResidencia: string;
}

export interface EditalListingFilterModel {
    anoPublicacao: string;
    tipoResidencia: number;
}

export interface EditalModel {
    anexos: EditalProgramaAnexoModel[];
    anosAdicionais: AnoAdicionalModel[];
    areasAtuacao: AreaAtuacaoModel[];
    areasConcentracao: AreaConcentracaoModel[];
    categoriasProfissionais: CategoriaProfissionalModel[];
    dataFimAdesao: string;
    dataFimAvaliacao: string;
    dataFimAvaliacaoRecurso: string;
    dataFimResidentes: string;
    dataFimSolicitacaoRecurso: string;
    dataInicioAdesao: string;
    dataInicioAvaliacao: string;
    dataInicioAvaliacaoRecurso: string;
    dataInicioResidentes: string;
    dataInicioSolicitacaoRecurso: string;
    dataPublicacao: string;
    declaracao: string;
    descricao: string;
    especialidades: EspecialidadeModel[];
    id: number;
    inscrito: boolean;
    link: string;
    migrado: boolean;
    naturezasJuridicas: NaturezaJuridicaModel[];
    nome: string;
    numeroInscricoes: number;
    retificacoes: RetificacaoModel[];
    secretariaObrigatoria: boolean;
    situacaoEdital: SituacaoEditalDomainModel;
    tempoRestante: string;
    tipoResidencia: TipoResidenciaDomainModel;
    tiposVaga: TipoVagaDomainModel[];
}

export interface EditalProgramaAnexoModel {
    descricao: string;
    extensoesValidas: string;
    id: number;
    obrigatorio: boolean;
    tamanhoMaximo: number;
}

export interface EmissaoSiafiModel {
    arquivo: ArquivoModel;
    competenciaId: number;
    dataEmissaoSiafi: Date;
    id: number;
    idUsuarioEmissor: number;
    nomeUsuarioEmissor: string;
    situacoesPagamento: SituacaoPagamentoDomainModel[];
}

export interface EnderecoModel {
    bairro: string;
    cep: string;
    complemento: string;
    id: number;
    logradouro: string;
    municipio: MunicipioModel;
    numero: string;
    semCEP: boolean;
    semNumero: boolean;
    uf: UFDomainModel;
}

export interface EscolaridadeDomainModel {
    codigoSiape: string;
    descricao: string;
    id: string;
}

export interface EspecialidadeDomainModel {
    area: string;
    descricao: string;
    duracao: string;
    duracaoNumerica: number;
    grandeArea: string;
    id: number;
    subArea: string;
}

export interface EspecialidadeModel {
    descricao: string;
    duracao: string;
    id: number;
}

export interface EstadoCivilDomainModel {
    codigoSiape: string;
    descricao: string;
    id: string;
}

export interface FaltaCompensadaModel {
    descricao: string;
    diasNaoCompensados: number;
    id: number;
}

export interface FinalizarSituacaoResidenteModel {
    certidaoNascimento: ArquivoAnexoModel;
    dataOcorrencia: string;
    dataPrevistaTermino: string;
    dataTermino: string;
    documentoComprobatorio: ArquivoAnexoModel;
    id: number;
    situacaoMatricula: SituacaoMatriculaDomainModel;
}

export interface FolhaModel {
    competencia: CompetenciaModel;
    id: number;
    numeroBolsas: number;
    situacaoFolha: SituacaoFolhaDomainModel;
}

export interface FormacaoDuracaoModel {
    descricao: string;
    duracao: string;
    duracaoId: number;
    id: number;
    tipo: TipoFormacaoDomainModel;
}

export interface GerenciamentoPagamentosFilterModel {
    competenciaId: number;
    situacoesPagamentos: SituacaoPagamentoDomainModel[];
}

export interface GrandeAreaDomainModel {
    descricao: string;
    id: number;
}

export interface GrauSatisfacaoDomainModel {
    descricao: string;
    id: number;
}

export interface HasIdModel<T> {
    id: T;
}

export interface InfoProgramaModel {
    hashPrograma: string;
    nomePrograma: string;
    programaId: number;
}

export interface InformacoesCoordenadorModel {
    cpf: string;
    email: string;
    nomeCoordenador: string;
    telefone: string;
}

export interface InformacoesInstitucionaisModel {
    bairroComissao: string;
    celularCoordenador: string;
    cepComissao: string;
    cnpj: string;
    complementoComissao: string;
    contatoComissao: string;
    coordenadorComissao: string;
    cpfCoordenador: string;
    emailComissao: string;
    emailCoordenador: string;
    hasNumero: boolean;
    logradouroComissao: string;
    municipioComissao: string;
    naturezaJuridica: string;
    nomeInstituicao: string;
    numeroComissao: string;
    razaoSocial: string;
    siglaComissao: string;
    telefoneComissao: string;
    tipoComissao: string;
    ufComissao: string;
}

export interface InformeRendimentoAnualModel {
    arquivoInformeAnualId: number;
    residenteCpf: string;
}

export interface InscricaoListModel {
    dataEnvio: string;
    idInscricao: number;
    idRecursoPrograma: number;
    numeroBolsasAprovadas: number;
    numeroBolsasAprovadasAvaliacao: number;
    numeroBolsasSolicitadas: number;
    periodoAvaliacao: PeriodoAvaliacaoDomainModel;
    periodoRecurso: PeriodoRecursoDomainModel;
    protocoloPCP: string;
    resultadoAvaliacao: ResultadoAvaliacaoDomainModel;
    resultadoRecurso: ResultadoRecursoDomainModel;
    situacaoInscricao: SituacaoInscricaoDomainModel;
    tipoResidencia: TipoResidenciaDomainModel;
    titulo: string;
}

export interface InscricaoModel {
    coEdital: number;
    dadosInscricao: DadosInscricaoModel;
    declaracao: boolean;
    distribuicaoBolsas: DistribuicaoBolsaModel[];
    documentosAnexos: ArquivoAnexoModel[];
    idInscricao: number;
    resultadoAvaliacao: ResultadoAvaliacaoDomainModel;
    secretariasConveniadas: ArquivoAnexoModel[];
    situacaoInscricao: SituacaoInscricaoDomainModel;
    tipoResidencia: TipoResidenciaDomainModel;
}

export interface InscricaoTableItemModel {
    avaliador: string;
    codigoMS: number;
    numeroBolsasAprovadas: number;
    numeroBolsasSolicitadas: number;
    protocoloCNRM: string;
    razaoSocial: string;
    siglaUF: string;
    situacaoInscricao: SituacaoInscricaoDomainModel;
    tipoPrograma: string;
    tipoResidencia: string;
}

export interface InstituicaoExternaModel {
    cnpj: string;
    razaoSocial: string;
}

export interface InstituicaoModel {
    cnpj: string;
    coNaturezaJuridica: string;
    coNaturezaJuridicaConcla: string;
    comissoes: ComissaoModel[];
    descricaoNaturezaJuridica: string;
    id: number;
    nomeFantasia: string;
    razaoSocial: string;
    vinculos: VinculoInstituicaoModel[];
}

export interface InstituicaoTransferenciaFilterModel {
    anoResidencia: AnoResidenciaDomainModel;
    cnpj: string;
    isCoreme: boolean;
    isSolicitacaoResidente: boolean;
    nomePrograma: string;
    tipoTransferencia: TipoTransferenciaDomainModel;
}

export interface InstituicaoTransferenciaModel {
    cnpj: string;
    municipio: string;
    razaoSocial: string;
    uf: string;
}

export interface ListagemConclusaoResidenciaFilterModel {
    cnpj: string;
    dataConclusao: string;
    filtroInstituicao: string;
    tipoComissao: number;
}

export interface LoteResidenciaConcluidaModel {
    cnpj: string;
    dataConclusao: string;
    id: number;
    oficioComissao: ArquivoAnexoModel;
    razaoSocial: string;
    residenciasConcluidas: number;
    responsavel: string;
}

export interface ManutencaoTimeInfoModel {
    deltaTimeSeconds: number;
    remoteTime: Date;
    systemTime: Date;
    systemTimeZone: string;
}

export interface MatriculaHistoricoPayloadModel {
    matriculaHistoricos: MatriculaHistoricoRowModel[];
    pageInfo: PageInfoModel;
}

export interface MatriculaHistoricoRowModel {
    anoResidencia: AnoResidenciaDomainModel;
    dataCadastro: string;
    dataFinalizacao: string;
    dataOcorrencia: string;
    dataTermino: string;
    matriculaAntigaId: number;
    matriculaHistoricoId: number;
    nomePrograma: string;
    prorrogacaoLicencaMaternidade: boolean;
    situacaoMatricula: SituacaoMatriculaDomainModel;
}

export interface MatriculaProgramaModel {
    descricao: string;
    id: number;
    programaHash: string;
    programaId: number;
}

export interface MatriculadoModel {
    agencia: string;
    anoResidencia: AnoResidenciaDomainModel;
    banco: BancoDomainModel;
    conta: string;
    cpf: string;
    digito: string;
    id: number;
    nome: string;
    situacaoMatricula: SituacaoMatriculaDomainModel;
    situacaoMatriculaDesatualizada: boolean;
    tipoConta: TipoContaDomainModel;
    tipoPagamento: TipoPagamentoDomainModel;
}

export interface ModalidadeProgramaDomainModel {
    descricao: string;
    id: number;
}

export interface MunicipioModel {
    descricao: string;
    id: string;
    ufId: string;
}

export interface NacionalidadeDomainModel {
    codigoSiape: string;
    descricao: string;
    id: number;
}

export interface NaturezaJuridicaModel {
    codigo: string;
    codigoConcla: string;
    descricao: string;
    tipoNaturezaJuridica: TipoNaturezaJuridicaModel;
}

export interface NovaSenhaModel {
    confirmarSenha: string;
    novaSenha: string;
    senhaAtual: string;
}

export interface OcorrenciaCompensacaoModel {
    competenciaId: number;
    diasCompensados: number;
    hashOrId: string;
    justificativa: string;
    ocorrenciaFaltaId: number;
}

export interface OcorrenciaFaltaModel {
    competenciaId: number;
    dataFim: string;
    dataInicio: string;
    hashOrId: string;
    justificativa: string;
    matriculaId: number;
}

export interface OcorrenciaModel {
    dataFim: string;
    dataInicio: string;
    dataRegistro: Date;
    historicoMatriculaId: number;
    id: number;
    justificativa: string;
    matriculaId: number;
    nomeAutor: string;
    numeroDias: number;
    referencia: number;
    situacaoMatricula: SituacaoMatriculaDomainModel;
    tipoOcorrencia: TipoOcorrenciaDomainModel;
}

export interface OrgaoEmissorRGDomainModel {
    descricao: string;
    id: string;
    siglaOrgaoEmissor: string;
}

export interface OrigemTransferenciaDomainModel {
    descricao: string;
    id: number;
}

export interface PagamentoProgramaTablePageModel {
    content: FolhaModel[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export interface PagamentoResidenteModel {
    dataCompetencia: string;
    demonstrativoId: number;
    faltasCompensadas: number;
    faltasRegistradas: number;
    situacaoPagamento: SituacaoPagamentoDomainModel;
    valorPagamento: number;
}

export interface PageInfoModel {
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    sort: string[];
    totalElements: number;
    totalPages: number;
}

export interface PaisModel {
    codigoSiape: string;
    descricao: string;
    id: number;
}

export interface PeriodoAvaliacaoDomainModel {
    descricao: string;
    id: number;
}

export interface PeriodoRecursoDomainModel {
    descricao: string;
    id: number;
}

export interface PortariaModel {
    arquivoHash: string;
    arquivoId: number;
    arquivoNome: string;
    dataRegistro: string;
    editalId: number;
    nome: string;
}

export interface PrazoExtemporaneoModel {
    dataFimResidentes: string;
    dataInicioResidentes: string;
    id: number;
    programaId: string;
}

export interface ProcessamentoOcorrenciaModel {
    cancelavel: boolean;
    concluido: boolean;
    contestacaoId: number;
    dataFim: string;
    dataInicio: string;
    demonstrativoId: number;
    numeroDias: number;
    ocorrencia: OcorrenciaModel;
    ocorrenciaId: number;
    ocorrenciaRelacionada: OcorrenciaModel;
    referencia: number;
    tipoContestacao: number;
}

export interface ProgramaDestinoModel {
    anoResidencia: AnoResidenciaDomainModel;
    categoriaProfissional: CategoriaProfissionalDomainModel;
    hasBolsasDisponiveis: boolean;
    isMedicaSelecionada: boolean;
    programa: ProgramaInfoModel;
}

export interface ProgramaInfoModel {
    anoResidenciaCategoriaList: AnoResidenciaCategoriaModel[];
    descricao: string;
    hasAnoCategoriaProfissional: boolean;
    hasBolsasDisponiveis: boolean;
    id: number;
}

export interface ProgramaListFilterModel {
    anosAdicionais: number[];
    areasAtuacao: number[];
    areasConcentracao: number[];
    cnpj: string;
    codigoMS: number;
    especialidades: number[];
    razaoSocial: string;
    regiao: string;
    tipoComissao: number;
    uf: string;
}

export interface ProgramaListPayloadModel {
    pageInfo: PageInfoModel;
    programas: ProgramaTableItemModel[];
}

export interface ProgramaModel {
    anoInicio: string;
    cnpjInstituicao: string;
    dataFinalInclusaoResidentes: string;
    distribuicaoBolsas: DistribuicaoBolsaModel[];
    duracaoPrograma: string;
    duracaoProgramaNumerica: number;
    emailInstitucional: string;
    hashPrograma: string;
    id: number;
    informacoesCoordenador: InformacoesCoordenadorModel;
    informacoesSupervisor: InformacoesCoordenadorModel;
    naturezaJuridica: string;
    nomeInstituicao: string;
    nomePrograma: string;
    periodoInclusaoResidentes: boolean;
    razaoSocial: string;
    telefoneInstitucional: string;
    totalBolsasOciosas: number;
    totalBolsasOfertadas: number;
    totalResidentesMatriculados: number;
    totalResidentesMatriculadosEmR1: number;
}

export interface ProgramaMultiFilterModel {
    anoResidenciaId: number;
    categoriaProfissionalId: number;
    cnpj: string;
    codigoMs: number;
    isSolicitacaoResidente: boolean;
}

export interface ProgramaResidenteCounterModel {
    totalResidentesMatriculados: number;
    totalResidentesMatriculadosEmR1: number;
}

export interface ProgramaTableItemModel {
    areaConcentracao: string;
    cnpj: string;
    codigoMS: number;
    iniciadoEm: string;
    programaHash: string;
    razaoSocial: string;
    tipoPrograma: string;
    totalBolsasParaOferta: number;
}

export interface ProgramaTransferenciaModel {
    cnpj: string;
    codigoMs: number;
    dataInicioPagamentos: string;
    id: number;
    instituicao: string;
    programa: string;
    tipoResidenciaId: number;
    uf: string;
}

export interface ProventoBaseModel {
    dataInicioVigencia: string;
    dataRegistro: Date;
    id: number;
    valorBolsa: number;
}

export interface RacaCorDomainModel {
    codigoSiape: string;
    descricao: string;
    id: string;
}

export interface RecursoProgramaModel {
    bolsasAprovadas: number;
    distribuicaoBolsas: DistribuicaoBolsaModel[];
    documentoRecursoAdicional: ArquivoAnexoModel;
    motivoRecurso: string;
    parecerRecurso: string;
    periodoRecurso: PeriodoRecursoDomainModel;
    programaAnexos: ArquivoAnexoModel[];
    programaId: number;
    recursoProgramaId: number;
    resultadoRecurso: ResultadoRecursoDomainModel;
    secretariasConveniadas: ArquivoAnexoModel[];
}

export interface RegiaoDomainModel {
    descricao: string;
    id: string;
    nome: string;
}

export interface RegistroOcorrenciaModel {
    dataFim: string;
    dataInicio: string;
    faltasCompensadas: number;
    numeroDias: number;
    ocorrenciaId: number;
    referencia: number;
    tipoOcorrencia: TipoOcorrenciaDomainModel;
}

export interface RemoverTermoCompromissoModel {
    justificativa: string;
    programaId: string;
}

export interface ResidenteConclusaoResidenciaModel {
    cpf: string;
    matriculaId: number;
    nome: string;
    nomePrograma: string;
    tipoPagamento: TipoPagamentoDomainModel;
}

export interface ResidenteExternoModel {
    confirmarEmail: string;
    cpf: string;
    dataNascimento: string;
    email: string;
    nomeCompleto: string;
    telefone: string;
}

export interface ResidenteFilterModel {
    anoAdicional: number[];
    anoResidencia: number[];
    areaAtuacao: number[];
    areaConcentracao: number[];
    cnpj: string;
    codigoMs: number;
    especialidade: number[];
    isCoreme: boolean;
    nomeOrCpf: string;
    regiao: string;
    situacaoAuxilioMoradia: number;
    situacaoMatricula: number[];
    tipoPagamento: number;
    tipoPrograma: number;
    uf: string;
}

export interface ResidenteInfoModel {
    anoResidencia: AnoResidenciaDomainModel;
    cnpjInstituicao: string;
    cpf: string;
    email: string;
    matriculaId: number;
    nome: string;
    nomeInstituicao: string;
    nomePrograma: string;
    situacaoMatricula: SituacaoMatriculaDomainModel;
    tipoPagamento: TipoPagamentoDomainModel;
    token: string;
}

export interface ResidenteInformadoModel {
    anoResidencia: AnoResidenciaDomainModel;
    conselhoProfissional: ConselhoProfissionalDomainModel;
    cpf: string;
    dataIngresso: string;
    dataNascimento: string;
    matriculaId: number;
    nome: string;
    nomePrograma: string;
    programaId: number;
    razaoSocial: string;
    situacaoMatricula: SituacaoMatriculaDomainModel;
    tipoPagamento: TipoPagamentoDomainModel;
    token: string;
}

export interface ResidenteInternoModel {
    dadosResidente: ResidenteTransferenciaInfoModel;
    descricao: string;
    id: number;
}

export interface ResidenteItemModel {
    anoResidencia: number;
    codigoMs: number;
    cpf: string;
    hasFaltasSiafi: boolean;
    hasFolhaCompetenciaAtual: boolean;
    hashPrograma: string;
    matriculaDesatualizada: boolean;
    matriculaId: number;
    nome: string;
    nomePrograma: string;
    situacaoMatricula: number;
    tipoPagamentoId: number;
    uf: string;
}

export interface ResidenteMatriculadoDetailsModel {
    hasFaltasSiafi: boolean;
    programa: ProgramaModel;
    residente: ResidenteModel;
    residenteMatriculado: ResidenteMatriculadoModel;
}

export interface ResidenteMatriculadoFilterParamsModel {
    anoResidencia: AnoResidenciaDomainModel;
    categoriaProfissional: CategoriaProfissionalDomainModel;
    incluirMatriculasInativas: boolean;
    nomeOuCpf: string;
    situacaoMatricula: SituacaoMatriculaDomainModel;
}

export interface ResidenteMatriculadoModel {
    anoResidencia: AnoResidenciaDomainModel;
    categoriaProfissional: CategoriaProfissionalDomainModel;
    cpf: string;
    dataCadastro: string;
    elegivelTrancamentoMilitar: boolean;
    email: string;
    id: number;
    matriculaId: number;
    nome: string;
    recemMatriculado: boolean;
    situacaoMatricula: SituacaoMatriculaDomainModel;
    situacaoResidente: SituacaoResidenteModel;
    telefone: string;
    tipoPagamento: TipoPagamentoDomainModel;
    transferenciaId: number;
}

export interface ResidenteMatriculadoTransferenciaModel {
    residenteMatriculado: ResidenteMatriculadoModel;
    situacaoMatriculaDesatualizada: boolean;
    tipoComissaoId: number;
}

export interface ResidenteModel {
    auxilioMoradiaHomologado: boolean;
    dadosBancarios: DadosBancariosResidenteModel;
    dadosComplementares: DadosComplementaresModel;
    dadosResidente: DadosResidenteModel;
    dadosSenha: SenhaModel;
    id: number;
    matriculaId: number;
    situacaoAuxilioMoradia: SituacaoAuxilioMoradiaDomainModel;
    termoUsoAceito: boolean;
}

export interface ResidenteTableItemModel {
    categoriaProfissional: CategoriaProfissionalDomainModel;
    confirmarEmail: string;
    cpf: string;
    dataNascimento: string;
    email: string;
    id: number;
    nomeCompleto: string;
    programaId: string;
    telefone: string;
}

export interface ResidenteTransferenciaInfoModel {
    isMedica: boolean;
    programa: ProgramaInfoModel;
    residente: ResidenteMatriculadoModel;
    situacaoMatriculaDesatualizada: boolean;
}

export interface ResidenteUserModel {
    ativo: boolean;
    instituicao: InstituicaoModel;
    matriculaId: number;
    programa: InfoProgramaModel;
    tipoPagamentoId: number;
}

export interface ResponsavelPagamentoModel {
    competenciaId: number;
    dadosPessoais: DadosPessoaisModel;
    enderecoCompleto: string;
    id: number;
}

export interface RespostaPesquisaRequestModel {
    comentario: string;
    grauSatisfacao: GrauSatisfacaoDomainModel;
}

export interface RespostaPesquisaResponseModel {
    comentario: string;
    dataCriacao: Date;
    grauSatisfacao: GrauSatisfacaoDomainModel;
    hashUsuario: string;
    id: number;
    papeisUsuario: RoleDomainModel[];
    versaoSistema: string;
}

export interface ResultadoAvaliacaoDomainModel {
    descricao: string;
    id: number;
}

export interface ResultadoPagamentoListModel {
    competenciaId: number;
    dataResultadoPagamento: Date;
    id: number;
    idUsuarioEmissor: number;
    nomeUsuarioEmissor: string;
    qtResidentesMarcadosErro: number;
    qtResidentesPagos: number;
    relatorioImportacao: ArquivoModel;
}

export interface ResultadoPagamentoModel {
    competenciaId: number;
    cpfsResidentesComErroFile: ArquivoModel;
    marcarTodosComoPagos: boolean;
}

export interface ResultadoRecursoDomainModel {
    descricao: string;
    id: number;
}

export interface ResultadoTransferenciaModel {
    anexoConfirmacaoMatriculaResidente: ArquivoAnexoModel;
    anexoCopiaDecisaoJudicial: ArquivoAnexoModel;
    anexoInformacaoDataFimAtividades: ArquivoAnexoModel;
    anexoOficioComissaoDestino: ArquivoAnexoModel;
    anexoOficioInformacaoTransferenciaResidente: ArquivoAnexoModel;
    anexoParecerCNRMDescredenciamento: ArquivoAnexoModel;
    anexoParecerCNRMTransferencia: ArquivoAnexoModel;
    anexoParecerCeremCodemuDestino: ArquivoAnexoModel;
    aprovada: boolean;
    dataInicioResidente: string;
    devolverParaSubstituicao: boolean;
    parecer: string;
    transferenciaId: number;
}

export interface ResumoDemonstrativoResidenteModel {
    ano: AnoResidenciaDomainModel;
    cpf: string;
    diasCompensados: number;
    nome: string;
    numeroFaltas: number;
    situacaoMatricula: SituacaoMatriculaDomainModel;
    totalReceber: number;
}

export interface ResumoReceitaPessoaFisicaModel {
    dataNascimento: string;
    id: number;
    nome: string;
}

export interface ResumoReceitaPessoaJuridicaModel {
    coNaturezaJuridica: string;
    descricaoNaturezaJuridica: string;
    municipioIbge: string;
    nomeFantasia: string;
    razaoSocial: string;
    siglaUf: string;
    ufIbge: string;
}

export interface RetificacaoModel {
    dataRegistro: Date;
    descricao: string;
    id: number;
    link: string;
}

export interface RoleDomainModel {
    descricao: string;
    id: number;
}

export interface RoleModel extends SerializableModel, HasIdModel<number> {
    id: number;
    name: string;
}

export interface SecretariaConveniadaDomainModel {
    descricao: string;
    id: number;
}

export interface SefipResidenteModel {
    nomeResidente: string;
    pis: string;
    valorBaseINSSCentavos: string;
    valorBaseINSSDecimal: number;
}

export interface SenhaModel {
    confirmarSenha: string;
    senha: string;
}

export interface SerializableModel {
}

export interface SexoDomainModel {
    descricao: string;
    id: string;
}

export interface SiafiDemonstrativoModel {
    agencia: string;
    coDemonstrativo: number;
    codigoBanco: string;
    contaBancaria: string;
    cpfResidente: string;
    digitoContaBancaria: string;
    digitoTipoBanco: string;
    idTipoPrograma: number;
    tipoResidencia: TipoResidenciaDomainModel;
    valorLiquidoCentavos: string;
    valorLiquidoDecimal: number;
}

export interface SituacaoAuxilioMoradiaDomainModel {
    descricao: string;
    id: number;
}

export interface SituacaoContestacaoDomainModel {
    descricao: string;
    id: number;
}

export interface SituacaoEditalDomainModel {
    descricao: string;
    id: number;
}

export interface SituacaoFolhaDomainModel {
    descricao: string;
    id: number;
}

export interface SituacaoInscricaoDomainModel {
    descricao: string;
    id: number;
}

export interface SituacaoMatriculaDomainModel {
    ativa: boolean;
    descricao: string;
    id: number;
}

export interface SituacaoPagamentoDomainModel {
    descricao: string;
    id: number;
}

export interface SituacaoResidenteInformadoModel {
    nomePrograma: string;
    razaoSocial: string;
    situacaoMatricula: SituacaoMatriculaDomainModel;
}

export interface SituacaoResidenteModel {
    dataOcorrencia: string;
    dataRegistro: string;
    dataTermino: string;
    documentoProrrogacaoLicenca: ArquivoAnexoModel;
    documentosComprobatorios: ArquivoAnexoModel[];
    id: number;
    justificativaAlteracao: string;
    licencaMaternidadeId: number;
    matriculaAntigaId: number;
    nomeAutor: string;
    numeroDias: number;
    prorrogacaoLicencaMaternidade: boolean;
    situacaoMatricula: SituacaoMatriculaDomainModel;
}

export interface SituacaoTransferenciaDomainModel {
    ativa: boolean;
    descricao: string;
    id: number;
}

export interface SolicitacaoTransferenciaModel {
    cnpjInstituicao: string;
    documentosSolicitacao: ArquivoAnexoModel[];
    origemTransferencia: OrigemTransferenciaDomainModel;
    programaDestino: ProgramaDestinoModel;
    residenteExterno: ResidenteExternoModel;
    residenteInterno: ResidenteInternoModel;
    tipoTransferencia: TipoTransferenciaDomainModel;
}

export interface SubAreaDomainModel {
    descricao: string;
    id: number;
}

export interface SubstituicaoDocumentoTransferenciaModel {
    arquivoId: number;
    documentoTransferenciaId: number;
    transferenciaId: number;
}

export interface SupervisorModel {
    confirmarEmail: string;
    dadosPessoais: DadosPessoaisModel;
    email: string;
    endereco: EnderecoModel;
    id: number;
    telefone: string;
    token: string;
}

export interface TermoCompromissoModel {
    arquivo: ArquivoModel;
    dtAnexo: string;
    id: number;
}

export interface TermoCompromissoMostRecentModel {
    currentYear: number;
    hasCurrentYearTermoCompromisso: boolean;
    termoCompromisso: TermoCompromissoModel;
}

export interface TermoCompromissoPayloadModel {
    pageInfo: PageInfoModel;
    termosCompromisso: TermoCompromissoModel[];
}

export interface TermoCompromissoTemplateModel {
    anoAtual: string;
    comissaoMunicipio: string;
    comissaoUf: string;
    coordenadorCpf: string;
    coordenadorNome: string;
    dataAtualPorExtenso: string;
    instituicaoCnpj: string;
    instituicaoNome: string;
    instituicaoUf: string;
    programaNome: string;
    supervisorCpf: string;
    supervisorNome: string;
}

export interface TermoCompromissoTestTemplateModel {
    termoCompromissoTemplate: TermoCompromissoTemplateModel;
    tipoResidencia: TipoResidenciaDomainModel;
}

export interface TipoComissaoDomainModel {
    descricao: string;
    id: number;
    sigla: string;
}

export interface TipoContaDomainModel {
    descricao: string;
    id: number;
}

export interface TipoContestacaoDomainModel {
    descricao: string;
    id: number;
}

export interface TipoFormacaoDomainModel {
    descricao: string;
    id: string;
}

export interface TipoNaturezaJuridicaModel {
    descricao: string;
    id: number;
}

export interface TipoOcorrenciaDomainModel {
    descricao: string;
    id: number;
}

export interface TipoPagamentoDomainModel {
    descricao: string;
    id: number;
}

export interface TipoProgramaDomainModel {
    descricao: string;
    id: number;
}

export interface TipoResidenciaDomainModel {
    descricao: string;
    id: number;
}

export interface TipoSanguineoDomainModel {
    descricao: string;
    fatorRH: string;
    grupoSanguineo: string;
    id: string;
}

export interface TipoTransferenciaDomainModel {
    descricao: string;
    id: number;
}

export interface TipoVagaDomainModel {
    descricao: string;
    id: number;
}

export interface TransferenciaCoordenadorItemModel {
    cnpjInstituicao: string;
    cpfResidente: string;
    dataSolicitacao: Date;
    id: number;
    nomeInstituicao: string;
    nomePrograma: string;
    situacaoTransferenciaId: number;
    tipoResidenciaId: number;
    tipoTransferenciaId: number;
}

export interface TransferenciaDegtsItemModel {
    cnpjInstituicao: string;
    cpf: string;
    dataSolicitacao: Date;
    id: number;
    nomeInstituicao: string;
    programa: string;
    situacaoTransferenciaId: number;
    tipoResidenciaId: number;
}

export interface TransferenciaModel {
    anoResidencia: AnoResidenciaDomainModel;
    dataInicioResidente: string;
    dataRegistro: Date;
    id: number;
    interestadual: boolean;
    matriculaDestinoId: number;
    matriculaOrigemId: number;
    origemTransferencia: OrigemTransferenciaDomainModel;
    parecerAnuencia: string;
    parecerFinal: string;
    programaDestino: ProgramaTransferenciaModel;
    programaOrigem: ProgramaTransferenciaModel;
    programaSolicitante: ProgramaTransferenciaModel;
    situacaoTransferencia: SituacaoTransferenciaDomainModel;
    tipoPrograma: TipoProgramaDomainModel;
    tipoTransferencia: TipoTransferenciaDomainModel;
}

export interface UFDomainModel {
    descricao: string;
    id: string;
    nome: string;
    siglaRegiao: string;
}

export interface UserModel {
    cpf: string;
    id: number;
    nome: string;
    pessoaCadastroId: number;
    residenteUser: ResidenteUserModel;
    roles: RoleModel[];
    vinculoAtual: VinculoModel;
    vinculos: VinculoModel[];
}

export interface ValorBolsaResidenciaModel {
    confirmacaoNovoValor: number;
    novoValor: number;
}

export interface ValorBolsaResidenciaPayloadModel {
    dataProximaCompetencia: string;
    proventoBaseAtual: ProventoBaseModel;
}

export interface VinculoInstituicaoModel {
    comissao: ComissaoModel;
    comissaoTipo: TipoComissaoDomainModel;
    coordenadorCpf: string;
    coordenadorEmail: string;
    coordenadorNome: string;
    coordenadorTelefone: string;
    instituicao: InstituicaoModel;
    vinculoInstituicaoId: number;
}

export interface VinculoModel {
    comissao: ComissaoModel;
    id: number;
    instituicao: InstituicaoModel;
    programa: InfoProgramaModel;
    role: RoleModel;
}

export interface VisualizarContestacaoModel {
    dadosResidente: MatriculadoModel;
    dataCadastro: string;
    dataCompetencia: string;
    declaracaoDiasAprovados: boolean;
    documentoComprobatorio: ArquivoAnexoModel;
    dtAvaliacao: string;
    dtContestacao: string;
    justificativaContestacao: string;
    nomeAvaliador: string;
    nomeInstituicao: string;
    nomePrograma: string;
    nuDiasCompensados: number;
    nuDiasIncorretos: number;
    ocorrencia: OcorrenciaModel;
    parecerAvaliacao: string;
    protocolo: number;
    referenciaCompensacao: number;
    resultadoAvaliacao: boolean;
    situacaoContestacao: SituacaoContestacaoDomainModel;
    tipoContestacao: TipoContestacaoDomainModel;
}

export interface VisualizarResidenciaConcluidaLoteModel {
    autor: string;
    dataConclusao: string;
    documentoComprobatorio: ArquivoAnexoModel;
    instituicao: string;
    lote: number;
    totalResidencias: number;
}


// Added by 'EnumTypeScriptModelListExtension' extension

export const AnoAdicionalDomainModelList = [
  { id: 1, descricao: "Transplante de coração", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 2, descricao: "Transplante de fígado", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 3, descricao: "Transplante de pâncreas", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 4, descricao: "Transplante de pulmão", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 5, descricao: "Transplante de rim", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 6, descricao: "Transplante de ossos", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 7, descricao: "Transplante de pele e anexos", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 8, descricao: "Transplante de córnea", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 9, descricao: "Transplantes realizados em crianças e adolescentes", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 10, descricao: "Cirurgia Geral - Programa Avançado", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 11, descricao: "Cirurgia / Cirurgia Do Trauma", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 12, descricao: "Transplante De Coração / Cirurgia Cardiovascular", duracao: "4 anos", duracaoNumerica: 4, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 13, descricao: "Transplante De Coração / Cardiologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 14, descricao: "Transplante De Fígado / Gastroenterologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 15, descricao: "Transplante De Fígado / Cirurgia Do Aparelho Digestivo", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 16, descricao: "Transplante De Pâncreas / Gastroenterologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 17, descricao: "Transplante De Pâncreas / Cirurgia Do Aparelho Digestivo", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 18, descricao: "Transplante De Pâncreas / Endocrinologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 19, descricao: "Transplante De Pulmão / Cirurgia Torácica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 20, descricao: "Transplante De Pulmão / Pneumologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 21, descricao: "Transplante De Rim / Nefrologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 22, descricao: "Transplante De Rim / Urologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 23, descricao: "Transplante De Rim / Cirurgia Vascular", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 24, descricao: "Transplante De Ossos / Ortopedia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 25, descricao: "Transplantes De Pele E Anexos / Cirurgia Plástica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 26, descricao: "Transplante De Córnea / Oftalmologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 27, descricao: "Transplantes Realizados Em Crianças E Adolescentes / Pediatria", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 28, descricao: "Transplantes Realizados Em Crianças E Adolescentes / Cirurgia Pediátrica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 29, descricao: "Cirurgia Geral - Opcional", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 30, descricao: "Clínica Médica - Opcional", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 31, descricao: "Obstetrícia E Ginecologia - Opcional", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 32, descricao: "Pediatria - Opcional", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 33, descricao: "Nefrologia - Ano Opcional", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 34, descricao: "Cardiologia - Ano Opcional", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 35, descricao: "Programa De Pré Requisito Em Área Cirúrgica Básica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
]

export const AnoResidenciaDomainModelList = [
  { id: 0, descricao: "Aguardando R1" },
  { id: 1, descricao: "R1" },
  { id: 2, descricao: "R2" },
  { id: 3, descricao: "R3" },
  { id: 4, descricao: "R4" },
  { id: 5, descricao: "R5" },
  { id: 6, descricao: "R6" },
  { id: 7, descricao: "R7" },
  { id: 8, descricao: "R8" },
  { id: 9, descricao: "R9" },
  { id: 10, descricao: "Integralização" },
]

export const AreaAtuacaoDomainModelList = [
  { id: 1, descricao: "Administração em Saúde", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Saúde Coletiva", subArea: "Gestão em Saúde" },
  { id: 2, descricao: "Alergia e Imunologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 3, descricao: "Angiorradiologia e Cirurgia Endovascular", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 4, descricao: "Atendimento ao Queimado", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 5, descricao: "Cardiologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 6, descricao: "Cirurgia Bariátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 7, descricao: "Cirurgia Crânio-Maxilo-Facial", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 8, descricao: "Cirurgia do Trauma", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 9, descricao: "Cirurgia Videolaparoscópica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 10, descricao: "Citopatologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 11, descricao: "Densitometria Óssea", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 12, descricao: "Dor", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 13, descricao: "Ecocardiografia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 14, descricao: "Ecografia Vascular com Doppler", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 15, descricao: "Eletrofisiologia Clínica Invasiva", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 16, descricao: "Emergência Pediátrica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 17, descricao: "Endocrinologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 18, descricao: "Endoscopia Digestiva", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 19, descricao: "Endoscopia Ginecológica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 20, descricao: "Endoscopia Respiratória", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 21, descricao: "Ergometria", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 22, descricao: "Estimulação Cardíaca Eletrônica Implantável", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 23, descricao: "Foniatria", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 24, descricao: "Gastroenterologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 25, descricao: "Hansenologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 26, descricao: "Hematologia e Hemoterapia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 27, descricao: "Hemodinâmica e Cardiologia Intervencionista", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 28, descricao: "Hepatologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 29, descricao: "Infectologia Hospitalar", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 30, descricao: "Infectologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 31, descricao: "Mamografia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 32, descricao: "Medicina Aeroespacial", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 33, descricao: "Medicina do Adolescente", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 34, descricao: "Medicina do Sono", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 35, descricao: "Medicina Fetal", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 36, descricao: "Medicina Intensiva Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 37, descricao: "Medicina Paliativa", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 38, descricao: "Medicina Tropical", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 39, descricao: "Nefrologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 40, descricao: "Neonatologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 41, descricao: "Neurofisiologia Clínica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 42, descricao: "Neurologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 43, descricao: "Neurorradiologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 44, descricao: "Nutrição Parenteral e Enteral", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 45, descricao: "Nutrição Parenteral e Enteral Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 46, descricao: "Nutrologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 47, descricao: "Oncologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 48, descricao: "Pneumologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 49, descricao: "Psicogeriatria", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Psiquiatria" },
  { id: 50, descricao: "Psicoterapia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Psiquiatria" },
  { id: 51, descricao: "Psiquiatria da Infância e Adolescência", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Psiquiatria" },
  { id: 52, descricao: "Psiquiatria Forense", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Psiquiatria" },
  { id: 53, descricao: "Radiologia Intervencionista e Angiorradiologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 54, descricao: "Reprodução Assistida", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 55, descricao: "Reumatologia Pediátrica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 56, descricao: "Sexologia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 57, descricao: "Toxicologia Médica", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 58, descricao: "Transplante de Medula Óssea", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 59, descricao: "Ultrassonografia em Ginecologia e Obstetrícia", duracao: "1 ano", duracaoNumerica: 1, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
]

export const AreaConcentracaoDomainModelList = [
  { id: 2, descricao: "Atenção Básica / Saúde da Família", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 3, descricao: "Atenção Especializada Em Saúde", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 4, descricao: "Saúde Bucal", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 5, descricao: "Saúde Mental", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 6, descricao: "Saúde Do Idoso", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 7, descricao: "Saúde Da Mulher", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 8, descricao: "Saúde Da Criança", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 9, descricao: "Reabilitação Física", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 10, descricao: "Intensivismo / Medicina Intensiva", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 11, descricao: "Urgência / Trauma", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 12, descricao: "Alimentação E Nutrição", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 13, descricao: "Assistência Farmacêutica", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 14, descricao: "Vigilância Em Saúde", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 15, descricao: "Apoio Diagnóstico E Terapêutico", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 16, descricao: "Atenção Ao Câncer", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 17, descricao: "Saúde Coletiva", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 18, descricao: "Saúde Animal E Ambiental", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 19, descricao: "Atenção Clínica Especializada", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 20, descricao: "Atenção Cirúrgica Especializada", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 21, descricao: "Física Médica", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 22, descricao: "Enfermagem Obstétrica", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 23, descricao: "Saúde Funcional E Reabilitação", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 24, descricao: "Cirurgia E Traumatologia Bucomaxilofacial", duracao: "3 anos", duracaoNumerica: 3 },
  { id: 25, descricao: "Saúde Materno Infantil", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 26, descricao: "Atenção Clínica Especializada: Cardiopulmonar", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 27, descricao: "Atenção Clínica Especializada: Infectologia", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 28, descricao: "Atenção Clínica Especializada: Neurologia", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 29, descricao: "Atenção Clínica Especializada: Neurocirurgia", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 30, descricao: "Atenção Clínica Especializada: Ortopedia", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 31, descricao: "Nutrição Clínica", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 32, descricao: "Reabilitação", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 33, descricao: "Urgência E Emergência", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 34, descricao: "Neurologia", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 35, descricao: "Neonatologia", duracao: "2 anos", duracaoNumerica: 2 },
  { id: 36, descricao: "Hematologia", duracao: "2 anos", duracaoNumerica: 2 },
]

export const AreaDomainModelList = [
  { id: 1, descricao: "Medicina" },
  { id: 2, descricao: "Genética" },
  { id: 3, descricao: "Saúde Coletiva" },
]

export const BancoDomainModelList = [
  { id: '001', descricao: "001 - BANCO DO BRASIL S.A." },
  { id: '002', descricao: "002 - BANCO CENTRAL DO BRASIL" },
  { id: '003', descricao: "003 - BANCO DA AMAZONIA S.A." },
  { id: '004', descricao: "004 - BANCO DO NORDESTE DO BRASIL S.A." },
  { id: '007', descricao: "007 - BANCO NACIONAL DE DESENV.ECONOMICO E SOCIAL" },
  { id: '010', descricao: "010 - CC CREDICOAMO CREDITO RURAL COOPERATIVA" },
  { id: '011', descricao: "011 - CREDIT SUISSE HEDGING-GRIFFO CORRETORA S.A." },
  { id: '012', descricao: "012 - BANCO INBURSA DE INVESTIMENTOS S.A." },
  { id: '014', descricao: "014 - STATE STREET BRASIL S.A. BCO COMERCIAL" },
  { id: '016', descricao: "016 - SICOOB CREDITRAN" },
  { id: '017', descricao: "017 - BNY MELLON BANCO S.A." },
  { id: '018', descricao: "018 - BANCO TRICURY S.A." },
  { id: '021', descricao: "021 - BANCO DO ESTADO DO ESPIRITO SANTO S.A." },
  { id: '024', descricao: "024 - BANCO BANDEPE S.A." },
  { id: '025', descricao: "025 - BANCO ALFA S.A." },
  { id: '029', descricao: "029 - BANCO ITAU CONSIGNADO S.A." },
  { id: '033', descricao: "033 - BANCO SANTANDER (BRASIL)S.A." },
  { id: '036', descricao: "036 - BANCO BRADESCO BBI" },
  { id: '037', descricao: "037 - BANCO DO ESTADO DO PARA S.A." },
  { id: '040', descricao: "040 - BANCO CARGILL S.A." },
  { id: '041', descricao: "041 - BANCO DO ESTADO DO RIO GRANDE DO SUL S.A." },
  { id: '047', descricao: "047 - BANCO DO ESTADO DE SERGIPE S.A." },
  { id: '060', descricao: "060 - CONFIDENCE CORRETORA DE CAMBIO S.A" },
  { id: '062', descricao: "062 - HIPERCARD BANCO MULTIPLO S.A" },
  { id: '063', descricao: "063 - BANCO BRADESCARD S.A." },
  { id: '064', descricao: "064 - GOLDMAN SACHS DO BRASIL BANCO MULTIPLO SA" },
  { id: '065', descricao: "065 - BANCO ANDBANK (BRASIL) S.A." },
  { id: '066', descricao: "066 - BANCO MORGAN STANLEY DEAN WITTER S.A." },
  { id: '069', descricao: "069 - BANCO CREFISA S.A." },
  { id: '070', descricao: "070 - BRB-BANCO DE BRASILIA S.A." },
  { id: '074', descricao: "074 - BANCO J.SAFRA S.A." },
  { id: '075', descricao: "075 - BCO ABN AMRO S.A." },
  { id: '076', descricao: "076 - KDB DO BRASIL" },
  { id: '077', descricao: "077 - BANCO INTERMEDIUM S.A" },
  { id: '078', descricao: "078 - BI HAITONG DO BRASIL" },
  { id: '079', descricao: "079 - BANCO ORIGINAL DO AGRONEGOCIO S.A." },
  { id: '080', descricao: "080 - B&T ASSOCIADOS CORRETORA DE CAMBIO LTDA" },
  { id: '081', descricao: "081 - BANCO SEGURO S.A." },
  { id: '082', descricao: "082 - BANCO TOPAZIO S.A." },
  { id: '083', descricao: "083 - BANCO DA CHINA BRASIL S.A." },
  { id: '084', descricao: "084 - CC UNIPRIME NORTE DO PARANA" },
  { id: '085', descricao: "085 - CCC AILOS" },
  { id: '088', descricao: "088 - BANCO RANDON S.A" },
  { id: '089', descricao: "089 - CREDISAN COOPERATIVA DE CREDITO" },
  { id: '091', descricao: "091 - CC UNICRED CENTRAL RS" },
  { id: '092', descricao: "092 - BRK S.A CREDITO, FINANCIAMENTO E INVEST." },
  { id: '093', descricao: "093 - POLOCRED SOCIEDADE CREDITO MICROEMPREENDEDOR" },
  { id: '094', descricao: "094 - BANCO FINAXIS S.A." },
  { id: '095', descricao: "095 - TRAVELEX BANCO DE CAMBIO S.A." },
  { id: '096', descricao: "096 - BANCO B3 S.A." },
  { id: '097', descricao: "097 - CREDISIS LTDA" },
  { id: '098', descricao: "098 - CREDIALIANCA COOPERATIVA CREDITO RURAL" },
  { id: '099', descricao: "099 - UNIPRIME CENTRAL" },
  { id: '100', descricao: "100 - PLANNER CORRETORA DE VALORES S.A." },
  { id: '101', descricao: "101 - DTVM RENANSCENCA" },
  { id: '102', descricao: "102 - XP INVESTIMENTOS CCTVM S.A." },
  { id: '104', descricao: "104 - CAIXA ECONOMICA FEDERAL" },
  { id: '105', descricao: "105 - LECCA CREDITO, FINACIAMENTO E INVESTIMENTO" },
  { id: '107', descricao: "107 - BANCO BOCOM BBM S.A." },
  { id: '108', descricao: "108 - PORTOCRED S.A. CREDITO, FINANCIAMENTO E INV." },
  { id: '111', descricao: "111 - OLIVEIRA TRUST DIST. DE TITULOS E VALORES SA." },
  { id: '113', descricao: "113 - MAGLIANO S/A CORRETORA DE CAMBIO VALORES MOB" },
  { id: '114', descricao: "114 - CENTRAL COOP.CRED. ESTADO ESP. SANTO CECOOP" },
  { id: '117', descricao: "117 - ADVANCED CORRETORA DE CAMBIO LTDA" },
  { id: '119', descricao: "119 - WESTERN UNION DO BRASIL S.A." },
  { id: '120', descricao: "120 - BANCO RODOBENS S.A." },
  { id: '121', descricao: "121 - BANCO AGIBANK S.A." },
  { id: '122', descricao: "122 - BANCO BERJ S.A." },
  { id: '124', descricao: "124 - BANCO WOORI BANK DO BRASIL S.A." },
  { id: '125', descricao: "125 - BRASIL PLURAL S.A. BANCO MULTIPLO" },
  { id: '126', descricao: "126 - BR PARTNERS BANCO DE INVESTIMENTO S.A." },
  { id: '127', descricao: "127 - CODEPE-CORRETORA DE VALORES S.A." },
  { id: '128', descricao: "128 - MSB BANK S.A. BANCO DE CAMBIO" },
  { id: '129', descricao: "129 - UBS BRASIL BANCO DE INVESTIMENTO S.A." },
  { id: '130', descricao: "130 - CARUANA S.A. SOCIEDADE CREDITO, FINAC. E INV." },
  { id: '131', descricao: "131 - TULLETT PREBON BRASIL-CORRETORA VALORES" },
  { id: '132', descricao: "132 - ICBC DO BRASIL" },
  { id: '133', descricao: "133 - CRESOL CONFEDERACAO" },
  { id: '134', descricao: "134 - BGC LIQUIDEZ DISTR.TITULOS E VAL. MOBILIARIOS" },
  { id: '136', descricao: "136 - CC UNICRED DO BRASIL" },
  { id: '138', descricao: "138 - SC GET MONEY" },
  { id: '139', descricao: "139 - INTENSA SANPAOLO" },
  { id: '140', descricao: "140 - SC EASYNVEST" },
  { id: '142', descricao: "142 - BROKER BRASIL CORRETORA DE CAMBIO LTDA" },
  { id: '143', descricao: "143 - TREVISO CORRETORA DE CAMBIO S.A." },
  { id: '144', descricao: "144 - BEXS_BANCO DE CAMBIO S/A" },
  { id: '145', descricao: "145 - SC LEVYCAM" },
  { id: '146', descricao: "146 - SC GUITTA" },
  { id: '149', descricao: "149 - SCFI FACTA FINANCEIRA" },
  { id: '157', descricao: "157 - ICAP DO BRASIL CORRETORA DE TíTULOS E VALORES" },
  { id: '159', descricao: "159 - CASA DO CREDITO S.A. SOCIEDADE DE CREDITO AO" },
  { id: '163', descricao: "163 - COMMERZBANK BRASIL S.A. - BANCO MULTIPLO" },
  { id: '169', descricao: "169 - OLÉ BONSUCESSO CONSIGNADO" },
  { id: '173', descricao: "173 - BRL TRUST DTVM S.A." },
  { id: '174', descricao: "174 - SCFI PERNAMBUCANAS" },
  { id: '177', descricao: "177 - GUIDE INVESTIMENTOS S.A. CORRETORA DE VALORES" },
  { id: '180', descricao: "180 - SC CM CAPITAL MARKETS" },
  { id: '183', descricao: "183 - SOCRED S.A. - SOC.DE CRED. AO MICROEMP.E EPP" },
  { id: '184', descricao: "184 - BANCO ITAU-BBA S.A." },
  { id: '188', descricao: "188 - ATIVA INVESTIMENTOS S.S. CORRETORA DE TITULOS" },
  { id: '189', descricao: "189 - HS FINANCEIRA S.A. CREDITO, FIN. E INVEST." },
  { id: '190', descricao: "190 - COOP. DE ECONOMIA E CREDITO MUTUO SERV. PUBL." },
  { id: '191', descricao: "191 - NOVA FUTURA CORRETORA DE TÍTULOS E VAL. MOB." },
  { id: '194', descricao: "194 - PARMETAL DISTRIB. TIT. E VALORES MOBILIARIOS" },
  { id: '196', descricao: "196 - SC FAIR" },
  { id: '197', descricao: "197 - STONE PAGAMENTOS S.A." },
  { id: '204', descricao: "204 - BRADESCO CARTOES" },
  { id: '208', descricao: "208 - BTG PACTUAL S.A." },
  { id: '212', descricao: "212 - BANCO ORIGINAL S.A." },
  { id: '213', descricao: "213 - BANCO ARBI S.A." },
  { id: '214', descricao: "214 - BANCO DIBENS S.A." },
  { id: '217', descricao: "217 - BANCO JOHN DEERE S.A." },
  { id: '218', descricao: "218 - BANCO BS2 S.A." },
  { id: '222', descricao: "222 - BANCO CREDIT AGRICOLE BRASIL S.A." },
  { id: '224', descricao: "224 - BANCO FIBRA S/A" },
  { id: '233', descricao: "233 - BANCO CIFRA S.A." },
  { id: '237', descricao: "237 - BANCO BRADESCO SA" },
  { id: '241', descricao: "241 - BANCO CLASSICO S.A." },
  { id: '243', descricao: "243 - BANCO MAXIMA S.A." },
  { id: '246', descricao: "246 - BANCO ABC BRASIL S.A." },
  { id: '249', descricao: "249 - BANCO INVESTCRED UNIBANCO S.A." },
  { id: '250', descricao: "250 - BANCO DE CREDITO E VAREJO S.A." },
  { id: '253', descricao: "253 - BEXS CORRETORA DE CAMBIO S/A" },
  { id: '254', descricao: "254 - PARANA BANCO S.A." },
  { id: '259', descricao: "259 - MONEYCORP BANCO DE CÂMBIO SA" },
  { id: '260', descricao: "260 - NU PAGAMENTOS S.A." },
  { id: '265', descricao: "265 - BANCO FATOR S.A" },
  { id: '266', descricao: "266 - BANCO CEDULA S/A" },
  { id: '268', descricao: "268 - BARI COMPANHIA HIPOTECARIA" },
  { id: '269', descricao: "269 - BANCO HSBC S.A." },
  { id: '270', descricao: "270 - SAGITUR CORRETORA DE CAMBIO LTDA." },
  { id: '271', descricao: "271 - IB CCTVM LTDA" },
  { id: '272', descricao: "272 - AGK CORRETORA DE CAMBIO S.A." },
  { id: '273', descricao: "273 - COOP. DE CRED. RURAL DE SAO MIGUEL DO OESTE" },
  { id: '274', descricao: "274 - MONEY PLUS SCMEPP LTDA" },
  { id: '276', descricao: "276 - SENFF S.A. - CRED. FINANC. E INVESTIMENTO" },
  { id: '278', descricao: "278 - GENIAL INVESTIMENTOS CVM S.A." },
  { id: '279', descricao: "279 - COOP. CRED. RURAL DE PRIMAVERA DO LESTE" },
  { id: '280', descricao: "280 - AVISTA S.A. CREDITO, FINANC. E INVESTIMENTO" },
  { id: '281', descricao: "281 - COOPERATIVA DE CREDITO RURAL COOPAVEL" },
  { id: '283', descricao: "283 - RB CAPITAL INVESTIM. DTVM LTDA." },
  { id: '285', descricao: "285 - FRENTE CORRETORA DE CAMBIO LTDA" },
  { id: '286', descricao: "286 - COOPERATIVA DE CREDITO RURAL DE OURO SULCREDI" },
  { id: '288', descricao: "288 - CAROL DTVM LTDA" },
  { id: '289', descricao: "289 - DECYSEO CORRETORA DE CAMBIO LTDA" },
  { id: '290', descricao: "290 - PAGSEGURO INTERNET S.A." },
  { id: '292', descricao: "292 - BS2 DISTRIBUIDORA TIT. VALORES MOBILIARIOS SA" },
  { id: '293', descricao: "293 - LASTRO RDV DTVM LTDA" },
  { id: '296', descricao: "296 - VISION S.A. CORRETORA DE CAMBIO" },
  { id: '298', descricao: "298 - VIP'S CORRETORA DE CAMBIO LTDA SA" },
  { id: '299', descricao: "299 - SOROCRED CREDITO, FIN. E INVESTIMENTO SA" },
  { id: '300', descricao: "300 - BANCO DE LA NACION ARGENTINA" },
  { id: '301', descricao: "301 - BPP INSTITUICAO DE PAGAMENTO S.A." },
  { id: '306', descricao: "306 - PORTOPAR DTVM LTDA" },
  { id: '307', descricao: "307 - TERRA INVEST. DISTRIB. DE TIT.VALORES IMOBILI" },
  { id: '309', descricao: "309 - CAMBIONET CORRETORA DE CAMBIO LTDA." },
  { id: '310', descricao: "310 - VORTX DISTRIB. TIT. E VAL. MOBILIARIOS LTDA." },
  { id: '312', descricao: "312 - HSCM - SCMEPP" },
  { id: '315', descricao: "315 - PI DISTRIBUIDORA DE TIT. E VAL. MOBILIARIOS" },
  { id: '318', descricao: "318 - BANCO BMG S.A." },
  { id: '319', descricao: "319 - OM DISTRIB.TITULOS E VALORES MOBILIARIOS LTDA" },
  { id: '320', descricao: "320 - CCB BRASIL" },
  { id: '321', descricao: "321 - CREFAZ SCMEPP LTDA" },
  { id: '322', descricao: "322 - COOPERATIVA DE CREDITO RURAL DE ABELARDO LUZ" },
  { id: '323', descricao: "323 - MERCADOPAGO.COM REPRESENTACOES LTDA" },
  { id: '324', descricao: "324 - CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A." },
  { id: '325', descricao: "325 - ORAMA DISTRIB. TITULOS E VALORES MOBILIARIOS" },
  { id: '326', descricao: "326 - PARATI CREDITO, FINANCIAMENTO E INVESTIM. S/A" },
  { id: '329', descricao: "329 - QI SOCIEDADE DE CREDITO DIRETO S.A." },
  { id: '330', descricao: "330 - BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS" },
  { id: '331', descricao: "331 - FRAM CAPITAL DTVM S.A." },
  { id: '332', descricao: "332 - ACESSO SOLUCOES DE PAGAMENTO S.A." },
  { id: '335', descricao: "335 - BANCO DIGIO S.A." },
  { id: '336', descricao: "336 - BANCO C6 S.A." },
  { id: '340', descricao: "340 - SUPER PAGAMENTOS E ADM. MEIOS ELETRONICOS SA." },
  { id: '341', descricao: "341 - BANCO ITAU UNIBANCO S.A." },
  { id: '342', descricao: "342 - CREDITAS SOCIEDADE DE CREDITO DIRETO S.A." },
  { id: '343', descricao: "343 - FFA SCMEPP LTDA" },
  { id: '348', descricao: "348 - BANCO XP S.A." },
  { id: '349', descricao: "349 - AMAGGI S.A.-CREDITO,FINANCIAMENTO E INVEST." },
  { id: '350', descricao: "350 - COOP. DE CRED. RURAL DE PEQUENOS AGRICULT." },
  { id: '352', descricao: "352 - TORO CORRETORA DE TITULOS E VAL. MOBILIARIOS" },
  { id: '354', descricao: "354 - NECTON INVESTIMENTOS S.A. CVM" },
  { id: '355', descricao: "355 - OTIMO SOCIEDADE DE CREDITO DIRETO S.A." },
  { id: '359', descricao: "359 - ZEMA CREDITO, FINANC. E INVESTIMENTO S.A." },
  { id: '360', descricao: "360 - TRINUS CAPITAL DTVM S.A." },
  { id: '362', descricao: "362 - CIELO S.A." },
  { id: '363', descricao: "363 - SOCOPA SOCIEDADE CORRETORA PAULISTA S.A." },
  { id: '364', descricao: "364 - GERENCIANET PAGAMENTOS DO BRASIL LTDA" },
  { id: '365', descricao: "365 - SOLIDUS S.A CTVM" },
  { id: '366', descricao: "366 - BANCO SOCIETE GENERALE BRASIL S.A." },
  { id: '367', descricao: "367 - VITREO DTVM S.A." },
  { id: '368', descricao: "368 - BANCO CSF S.A." },
  { id: '370', descricao: "370 - BANCO MIZUHO DO BRASIL S.A." },
  { id: '371', descricao: "371 - WARREN CORRETORA DE VALORES MOBILIARIOS E CAM" },
  { id: '373', descricao: "373 - U.P.P SOCIEDADE EMPRÉSTIMO ENTRE PESSOAS S.A" },
  { id: '374', descricao: "374 - REALIZE CREDITO, FINANC. E INVESTIMENTO S.A." },
  { id: '376', descricao: "376 - BANCO J.P.MORGAN S.A." },
  { id: '377', descricao: "377 - MS SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR" },
  { id: '378', descricao: "378 - BBC LEASING S.A. - ARRENDAMENTO MERCANTIL" },
  { id: '379', descricao: "379 - COOPERFORTE - COOP. ECON. E CRED. MUTUO F. IF" },
  { id: '380', descricao: "380 - PICPAY SERVICOS S.A." },
  { id: '381', descricao: "381 - BANCO MERCEDES-BENZ DO BRASIL SA" },
  { id: '382', descricao: "382 - FIDUCIA SOCIEDADE DE CREDITO" },
  { id: '383', descricao: "383 - BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS L" },
  { id: '384', descricao: "384 - GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICR" },
  { id: '386', descricao: "386 - NU FINANCEIRA" },
  { id: '387', descricao: "387 - BANCO TOYOTA DO BRASIL S.A." },
  { id: '389', descricao: "389 - BANCO MERCANTIL DO BRASIL S.A." },
  { id: '390', descricao: "390 - BANCO GM S.A." },
  { id: '391', descricao: "391 - COOP. CREDITO RURAL DE IBIAM - SULCREDI/IBIAM" },
  { id: '393', descricao: "393 - BANCO VOLKSWAGEN S.A." },
  { id: '394', descricao: "394 - BRADESCO FINANCIAMENTOS S.A." },
  { id: '395', descricao: "395 - GOLD DISTRIB. TÍTULOS E VALORES MOBILIARIOS" },
  { id: '396', descricao: "396 - HUB PAGAMENTOS S.A" },
  { id: '397', descricao: "397 - LISTO SOCIEDADE DE CREDITO DIRETO S.A." },
  { id: '398', descricao: "398 - IDEAL DTVM" },
  { id: '399', descricao: "399 - KIRTON BANK S.A.- BANCO MULTIPLO" },
  { id: '402', descricao: "402 - COBUCCIO SOCIEDADE DE CRÉDITO DIRETO" },
  { id: '403', descricao: "403 - CORA SOCIEDADE DE CRÉDITO DIRETO S.A." },
  { id: '404', descricao: "404 - SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A." },
  { id: '406', descricao: "406 - ACCREDITO - SOCIEDADE DE CRÉDITO DIRETO S.A." },
  { id: '407', descricao: "407 - INDIGO INVESTIMENTOS DTVM" },
  { id: '408', descricao: "408 - BONUSCRED SOCIEDADE DE CREDITO DIRETO S.A." },
  { id: '410', descricao: "410 - PLANNER" },
  { id: '411', descricao: "411 - VIA CERTA S.A." },
  { id: '412', descricao: "412 - BANCO CAPITAL S.A." },
  { id: '422', descricao: "422 - BANCO SAFRA S.A." },
  { id: '456', descricao: "456 - BANCO MUFG BRASIL S.A." },
  { id: '464', descricao: "464 - BANCO SUMITOMO MITSUI BRASILEIRO S.A." },
  { id: '473', descricao: "473 - BANCO CAIXA GERAL - BRASIL S.A." },
  { id: '477', descricao: "477 - CITIBANK N.A." },
  { id: '479', descricao: "479 - BANCO ITAUBANK S.A." },
  { id: '487', descricao: "487 - DEUTSCHE BANK S.A.BANCO ALEMAO" },
  { id: '488', descricao: "488 - JPMORGAN CHASE BANK" },
  { id: '492', descricao: "492 - ING BANK N.V." },
  { id: '494', descricao: "494 - BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY" },
  { id: '495', descricao: "495 - BANCO DE LA PROVINCIA DE BUENOS AIRES" },
  { id: '505', descricao: "505 - BANCO CREDIT SUISSE FIRST BOSTON GARANTIA S." },
  { id: '545', descricao: "545 - SENSO CORRETORA CAMBIO E VALORES MOBILIARIOS" },
  { id: '600', descricao: "600 - BANCO LUSO BRASILEIRO S/A" },
  { id: '604', descricao: "604 - BANCO INDUSTRIAL DO BRASIL S/A" },
  { id: '610', descricao: "610 - BANCO VR S.A." },
  { id: '611', descricao: "611 - BANCO PAULISTA S/A" },
  { id: '612', descricao: "612 - BANCO GUANABARA S.A." },
  { id: '613', descricao: "613 - OMNI BANCO S.A." },
  { id: '623', descricao: "623 - BANCO PAN S.A." },
  { id: '626', descricao: "626 - BANCO FICSA S/A" },
  { id: '630', descricao: "630 - BANCO SMARTBANK S.A." },
  { id: '633', descricao: "633 - BANCO RENDIMENTO S.A." },
  { id: '634', descricao: "634 - BANCO TRIANGULO S/A" },
  { id: '637', descricao: "637 - BANCO SOFISA S/A" },
  { id: '643', descricao: "643 - BANCO PINE S.A." },
  { id: '652', descricao: "652 - BANCO ITAU UNIBANCO_HOLDING" },
  { id: '653', descricao: "653 - BANCO INDUSVAL S/A" },
  { id: '654', descricao: "654 - BANCO DIGIMAIS S.A." },
  { id: '655', descricao: "655 - BANCO VOTORANTIM S/A" },
  { id: '707', descricao: "707 - BANCO DAYCOVAL S.A." },
  { id: '712', descricao: "712 - BM OURINVEST" },
  { id: '738', descricao: "738 - BANCO MORADA S/A" },
  { id: '739', descricao: "739 - CETELEM" },
  { id: '741', descricao: "741 - BANCO RIBEIRAO PRETO S/A" },
  { id: '743', descricao: "743 - BANCO SEMEAR S/A" },
  { id: '745', descricao: "745 - BANCO CITIBANK S/A" },
  { id: '746', descricao: "746 - BANCO MODAL S/A" },
  { id: '747', descricao: "747 - BANCO RABOBANK INTERNATIONAL BRASIL S.A." },
  { id: '748', descricao: "748 - BANCO COOPERATIVO SICREDI S.A." },
  { id: '751', descricao: "751 - SCOTIABANK BRASIL S.A. BANCO MULTIPLO" },
  { id: '752', descricao: "752 - BANCO BNP PARIBAS BRASIL S.A." },
  { id: '753', descricao: "753 - NBC BANK BRASIL S.A." },
  { id: '754', descricao: "754 - BANCO SISTEMA" },
  { id: '755', descricao: "755 - BANCO MERRILL LYNCH S/A" },
  { id: '756', descricao: "756 - BANCO COOPERATIVO DO BRASIL S/A" },
  { id: '757', descricao: "757 - BANCO KEB HANA DO BRASIL S.A." },
]

export const CategoriaProfissionalDomainModelList = [
  { id: 1, descricao: "Biomedicina" },
  { id: 2, descricao: "Biologia" },
  { id: 3, descricao: "Educação Física" },
  { id: 4, descricao: "Enfermagem" },
  { id: 5, descricao: "Farmácia" },
  { id: 6, descricao: "Fisioterapia" },
  { id: 7, descricao: "Fonoaudiologia" },
  { id: 8, descricao: "Medicina" },
  { id: 9, descricao: "Medicina Veterinária" },
  { id: 10, descricao: "Nutrição" },
  { id: 11, descricao: "Odontologia" },
  { id: 12, descricao: "Psicologia" },
  { id: 13, descricao: "Serviço Social" },
  { id: 14, descricao: "Terapia Ocupacional" },
  { id: 15, descricao: "Saúde Coletiva" },
  { id: 16, descricao: "Física Médica" },
  { id: 17, descricao: "Física" },
  { id: 18, descricao: "Ciência e Tecnologia" },
  { id: 19, descricao: "Matemática" },
  { id: 20, descricao: "História" },
  { id: 21, descricao: "Engenharia Ambiental" },
  { id: 22, descricao: "Pedagogia" },
  { id: 23, descricao: "Antropologia" },
  { id: 24, descricao: "Gestão Ambiental" },
]

export const ConselhoProfissionalDomainModelList = [
  { id: 1, descricao: "Conselho Federal de Biologia", abreviacao: "Biologia" },
  { id: 2, descricao: "Conselho Federal de Biomedicina", abreviacao: "Biomedicina" },
  { id: 3, descricao: "Conselho Federal de Educação Física", abreviacao: "Educação Física" },
  { id: 4, descricao: "Conselho Federal de Enfermagem", abreviacao: "Enfermagem" },
  { id: 5, descricao: "Conselho Federal de Farmácia", abreviacao: "Farmácia" },
  { id: 6, descricao: "Conselho Federal de Fisioterapia e Terapia Ocupacional", abreviacao: "Fisioterapia e Terapia Ocupacional" },
  { id: 7, descricao: "Conselho Federal de Fonoaudiologia", abreviacao: "Fonoaudiologia" },
  { id: 8, descricao: "Conselho Federal de Medicina", abreviacao: "Medicina" },
  { id: 9, descricao: "Conselho Federal de Medicina Veterinária", abreviacao: "Medicina Veterinária" },
  { id: 10, descricao: "Conselho Federal de Nutricionistas", abreviacao: "Nutricionistas" },
  { id: 11, descricao: "Conselho Federal de Psicologia", abreviacao: "Psicologia" },
  { id: 12, descricao: "Conselho Federal de Odontologia", abreviacao: "Odontologia" },
  { id: 13, descricao: "Conselho Federal de Serviço Social", abreviacao: "Serviço Social" },
  { id: 14, descricao: "Conselho Nacional de Técnicos em Radiologia", abreviacao: "Técnicos em Radiologia" },
  { id: 999, descricao: "Não se aplica", abreviacao: "Não se aplica" },
]

export const DocumentoComprobatorioDomainModelList = [
  { id: 1, descricao: "Atestado médico" },
  { id: 2, descricao: "Ofício da instituição" },
  { id: 3, descricao: "Certidão de nascimento da criança" },
  { id: 4, descricao: "Declaração assinada pelo residente" },
  { id: 5, descricao: "Termo de desistência assinado pelo residente" },
  { id: 6, descricao: "Parecer da CNRM" },
  { id: 7, descricao: "Requerimento da residente ou atestado médico de 180 dias" },
  { id: 8, descricao: "Ofício da instituição com período" },
  { id: 9, descricao: "Ofício da instituição com justificativa e período a ser descontado" },
  { id: 10, descricao: "Documento comprobatório" },
  { id: 11, descricao: "Ofício da comissão para conclusão de residência" },
]

export const DocumentoTransferenciaDomainModelList = [
  { id: 1, descricao: "Ofício da COREME/COREMU de origem" },
  { id: 2, descricao: "Ofício da COREME/COREMU de destino" },
  { id: 3, descricao: "Parecer CNRM/CNRMS da transferência" },
  { id: 4, descricao: "Parecer CNRM/CNRMS de descredenciamento" },
  { id: 5, descricao: "Parecer CEREM/CODEMU de destino de anuência à transferência" },
  { id: 6, descricao: "Cópia da decisão judicial com os autos do processo" },
  { id: 7, descricao: "Documento de informação com a data de fim das atividades" },
  { id: 8, descricao: "Ofício de informação da transferência do residente" },
  { id: 9, descricao: "Termo de anuência" },
  { id: 10, descricao: "Documento de confirmação da matrícula do residente" },
]

export const DuracaoProgramaDomainModelList = [
  { id: 1, descricao: "1 ano" },
  { id: 2, descricao: "2 anos" },
  { id: 3, descricao: "3 anos" },
  { id: 4, descricao: "4 anos" },
  { id: 5, descricao: "5 anos" },
]

export const EscolaridadeDomainModelList = [
  { id: '08', descricao: "Superior completo", codigoSiape: "10" },
  { id: '09', descricao: "Especialização / Residência", codigoSiape: "10" },
  { id: '10', descricao: "Mestrado", codigoSiape: "13" },
  { id: '11', descricao: "Doutorado", codigoSiape: "14" },
]

export const EspecialidadeDomainModelList = [
  { id: 1, descricao: "Acupuntura", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 2, descricao: "Alergia e Imunologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 3, descricao: "Anestesiologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 4, descricao: "Angiologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 5, descricao: "Cardiologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 6, descricao: "Cirurgia Cardiovascular", duracao: "4 anos", duracaoNumerica: 4, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 7, descricao: "Cirurgia da Mão", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 8, descricao: "Cirurgia da Cabeça e Pescoço", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 9, descricao: "Cirurgia do Aparelho Digestivo", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 10, descricao: "Cirurgia Geral", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 11, descricao: "Cirurgia Oncológica", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 12, descricao: "Cirurgia Pediátrica", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 13, descricao: "Cirurgia Plástica", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 14, descricao: "Cirurgia Torácica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 15, descricao: "Cirurgia Vascular", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Cirurgia" },
  { id: 16, descricao: "Clínica Médica", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 17, descricao: "Coloproctologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 18, descricao: "Dermatologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 19, descricao: "Endocrinologia e Metabologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 20, descricao: "Endoscopia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 21, descricao: "Gastroenterologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 22, descricao: "Genética Médica", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências Biológicas", area: "Genética", subArea: "Genética Humana e Médica" },
  { id: 23, descricao: "Geriatria", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 24, descricao: "Ginecologia e Obstetrícia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 25, descricao: "Hematologia e Hemoterapia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 26, descricao: "Homeopatia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 27, descricao: "Infectologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 28, descricao: "Mastologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 29, descricao: "Medicina de Emergência", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 30, descricao: "Medicina de Família e Comunidade", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 31, descricao: "Medicina do Trabalho", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 32, descricao: "Medicina de Tráfego", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 33, descricao: "Medicina Esportiva", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 34, descricao: "Medicina Física e Reabilitação", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 35, descricao: "Medicina Intensiva", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 36, descricao: "Medicina Legal e Perícia Médica", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Medicina Legal e Deontologia" },
  { id: 37, descricao: "Medicina Nuclear", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 38, descricao: "Medicina Preventiva e Social", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 39, descricao: "Nefrologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 40, descricao: "Neurocirurgia", duracao: "5 anos", duracaoNumerica: 5, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 41, descricao: "Neurologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 42, descricao: "Nutrologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 43, descricao: "Oftalmologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 44, descricao: "Oncologia Clínica", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 45, descricao: "Ortopedia e Traumatologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 46, descricao: "Otorrinolaringologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 47, descricao: "Patologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 48, descricao: "Patologia Clínica / Medicina Laboratorial", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 49, descricao: "Pediatria", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 50, descricao: "Pneumologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 51, descricao: "Psiquiatria", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Psiquiatria" },
  { id: 52, descricao: "Radiologia e Diagnóstico por Imagem", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 53, descricao: "Ultrassonografia Geral", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 54, descricao: "Radiologia Intervencionista e Angiorradiologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 55, descricao: "Radioterapia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 56, descricao: "Reumatologia", duracao: "2 anos", duracaoNumerica: 2, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
  { id: 57, descricao: "Urologia", duracao: "3 anos", duracaoNumerica: 3, grandeArea: "Ciências da Saúde", area: "Medicina", subArea: "Clínica Médica" },
]

export const EstadoCivilDomainModelList = [
  { id: '01', descricao: "Casado", codigoSiape: "2" },
  { id: '02', descricao: "Solteiro", codigoSiape: "1" },
  { id: '03', descricao: "Divorciado/Separado", codigoSiape: "4" },
  { id: '05', descricao: "Viúvo", codigoSiape: "5" },
  { id: '06', descricao: "União estável", codigoSiape: "2" },
]

export const GrandeAreaDomainModelList = [
  { id: 1, descricao: "Ciências da Saúde" },
  { id: 2, descricao: "Ciências Biológicas" },
]

export const GrauSatisfacaoDomainModelList = [
  { id: 1, descricao: "Muito insatisfeito" },
  { id: 2, descricao: "Insatisfeito" },
  { id: 3, descricao: "Neutro" },
  { id: 4, descricao: "Satisfeito" },
  { id: 5, descricao: "Muito satisfeito" },
]

export const ModalidadeProgramaDomainModelList = [
  { id: 1, descricao: "Uniprofissional" },
  { id: 2, descricao: "Multiprofissional" },
]

export const NacionalidadeDomainModelList = [
  { id: 1, descricao: "BRASILEIRA", codigoSiape: "1" },
  { id: 4, descricao: "ESTRANGEIRA", codigoSiape: "4" },
]

export const OrgaoEmissorRGDomainModelList = [
  { id: '1', descricao: "SSP", siglaOrgaoEmissor: "SSP" },
  { id: '2', descricao: "Ministérios Militares", siglaOrgaoEmissor: "Minis" },
  { id: '3', descricao: "Ministério da Aeronáutica", siglaOrgaoEmissor: "Minis" },
  { id: '4', descricao: "Ministério do Exército", siglaOrgaoEmissor: "Minis" },
  { id: '5', descricao: "Ministério da Marinha", siglaOrgaoEmissor: "Minis" },
  { id: '6', descricao: "Polícia Federal", siglaOrgaoEmissor: "PF" },
  { id: '7', descricao: "Cart. Ident. Classista", siglaOrgaoEmissor: "Cart." },
  { id: '8', descricao: "Conselho Reg. Administração", siglaOrgaoEmissor: "Conse" },
  { id: '9', descricao: "Conselho Reg. Assist. Social", siglaOrgaoEmissor: "Conse" },
  { id: '10', descricao: "Conselho Reg. Biblioteconomia", siglaOrgaoEmissor: "Conse" },
  { id: '11', descricao: "Conselho Reg. Enfermagem", siglaOrgaoEmissor: "Conse" },
  { id: '12', descricao: "Não Identificado (Emissor não cadastrado)", siglaOrgaoEmissor: "Não I" },
  { id: '13', descricao: "Documento Estrangeiro", siglaOrgaoEmissor: "Docum" },
]

export const OrigemTransferenciaDomainModelList = [
  { id: 1, descricao: "Solicitação do residente" },
  { id: 2, descricao: "Mandado judicial" },
  { id: 3, descricao: "Descredenciamento de programa" },
]

export const PeriodoAvaliacaoDomainModelList = [
  { id: 1, descricao: "NAO_INICIADO" },
  { id: 2, descricao: "EM_AVALIACAO" },
  { id: 3, descricao: "ENCERRADO" },
]

export const PeriodoRecursoDomainModelList = [
  { id: 1, descricao: "Não iniciado" },
  { id: 2, descricao: "Solicitação de recurso" },
  { id: 3, descricao: "Avaliação de recurso" },
  { id: 4, descricao: "Encerrado" },
]

export const RacaCorDomainModelList = [
  { id: '03', descricao: "Amarela", codigoSiape: "03" },
  { id: '01', descricao: "Branca", codigoSiape: "01" },
  { id: '05', descricao: "Indígena", codigoSiape: "05" },
  { id: '04', descricao: "Parda", codigoSiape: "04" },
  { id: '02', descricao: "Preta", codigoSiape: "06" },
  { id: '99', descricao: "Sem informação", codigoSiape: "09" },
]

export const RegiaoDomainModelList = [
  { id: '1', descricao: "N", nome: "Norte" },
  { id: '2', descricao: "NE", nome: "Nordeste" },
  { id: '3', descricao: "SE", nome: "Sudeste" },
  { id: '4', descricao: "S", nome: "Sul" },
  { id: '5', descricao: "CO", nome: "Centro-Oeste" },
]

export const ResultadoAvaliacaoDomainModelList = [
  { id: 3, descricao: "Homologada" },
  { id: 4, descricao: "Não homologada" },
  { id: 5, descricao: "Em avaliação" },
]

export const ResultadoRecursoDomainModelList = [
  { id: 1, descricao: "Homologado" },
  { id: 2, descricao: "Não homologado" },
]

export const RoleDomainModelList = [
  { id: 1, descricao: "ROLE_DEGTS" },
  { id: 2, descricao: "ROLE_COORDENADOR" },
  { id: 3, descricao: "ROLE_RESIDENTE" },
  { id: 4, descricao: "ROLE_SUPERVISOR" },
  { id: 5, descricao: "ROLE_FINANCEIRO" },
  { id: 6, descricao: "ROLE_DEV" },
  { id: 7, descricao: "ROLE_TRANSFERENCIA" },
  { id: 8, descricao: "ROLE_ADMINISTRADOR" },
]

export const SecretariaConveniadaDomainModelList = [
  { id: 1, descricao: "Secretaria de Saúde Municipal" },
  { id: 2, descricao: "Secretaria de Saúde Estadual" },
  { id: 3, descricao: "Secretaria de Saúde do Distrito Federal" },
]

export const SexoDomainModelList = [
  { id: 'F', descricao: "Feminino" },
  { id: 'M', descricao: "Masculino" },
]

export const SituacaoAuxilioMoradiaDomainModelList = [
  { id: 1, descricao: "Solicitado" },
  { id: 2, descricao: "Desistido" },
  { id: 3, descricao: "Recurso Solicitado" },
  { id: 4, descricao: "Suspenso" },
  { id: 5, descricao: "Reprovado" },
  { id: 6, descricao: "Aprovado" },
]

export const SituacaoContestacaoDomainModelList = [
  { id: 1, descricao: "Pendente" },
  { id: 2, descricao: "Aprovada" },
  { id: 3, descricao: "Reprovada" },
]

export const SituacaoEditalDomainModelList = [
  { id: 1, descricao: "Aberto" },
  { id: 2, descricao: "Encerrado" },
  { id: 3, descricao: "Aguardando início" },
]

export const SituacaoFolhaDomainModelList = [
  { id: 1, descricao: "Aberta" },
  { id: 2, descricao: "Fechada" },
]

export const SituacaoInscricaoDomainModelList = [
  { id: 1, descricao: "Avaliação pendente" },
  { id: 2, descricao: "Em rascunho" },
  { id: 3, descricao: "Homologada" },
  { id: 4, descricao: "Não homologada" },
  { id: 5, descricao: "Em avaliação" },
  { id: 6, descricao: "Em recurso" },
  { id: 7, descricao: "Não concluída" },
]

export const SituacaoMatriculaDomainModelList = [
  { id: 1, descricao: "Aguardando cadastro", ativa: true },
  { id: 2, descricao: "Matriculado", ativa: true },
  { id: 3, descricao: "Matrícula cancelada", ativa: false },
  { id: 4, descricao: "Desligado / Desistente", ativa: false },
  { id: 5, descricao: "Atestado médico + de 15 dias", ativa: true },
  { id: 6, descricao: "Licença maternidade", ativa: true },
  { id: 7, descricao: "Trancamento", ativa: true },
  { id: 8, descricao: "Residência concluída", ativa: false },
  { id: 9, descricao: "Transferido", ativa: false },
  { id: 10, descricao: "Trancamento militar", ativa: false },
  { id: 11, descricao: "Pendência de TCC", ativa: false },
  { id: 12, descricao: "Férias", ativa: true },
  { id: 13, descricao: "Suspenso", ativa: true },
  { id: 14, descricao: "Prorrogação de licença", ativa: true },
  { id: 15, descricao: "Cadastro incompleto", ativa: true },
]

export const SituacaoPagamentoDomainModelList = [
  { id: 1, descricao: "Aguardando" },
  { id: 2, descricao: "Encaminhado" },
  { id: 3, descricao: "Pago" },
  { id: 4, descricao: "Erro" },
  { id: 5, descricao: "Suspenso" },
  { id: 8, descricao: "Dados incompletos" },
  { id: 9, descricao: "Dados atualizados" },
]

export const SituacaoTransferenciaDomainModelList = [
  { id: 1, descricao: "Aguardando anuência do MS", ativa: true },
  { id: 2, descricao: "Aguardando parecer", ativa: true },
  { id: 3, descricao: "Anuência negada", ativa: false },
  { id: 4, descricao: "Aguardando confirmação do MS", ativa: true },
  { id: 5, descricao: "Transferência concluída", ativa: false },
  { id: 6, descricao: "Transferência negada", ativa: false },
  { id: 7, descricao: "Aguardando substituição de documento (anuência)", ativa: true },
  { id: 8, descricao: "Aguardando substituição de documento (confirmação)", ativa: true },
]

export const SubAreaDomainModelList = [
  { id: 1, descricao: "Clínica Médica" },
  { id: 2, descricao: "Cirurgia" },
  { id: 3, descricao: "Genética Humana e Médica" },
  { id: 4, descricao: "Medicina Legal e Deontologia" },
  { id: 5, descricao: "Psiquiatria" },
  { id: 6, descricao: "Gestão em Saúde" },
]

export const TipoComissaoDomainModelList = [
  { id: 1, descricao: "Comissão de Residência Médica", sigla: "COREME" },
  { id: 2, descricao: "Comissão de Residência Multiprofissional e Uniprofissional em Saúde", sigla: "COREMU" },
]

export const TipoContaDomainModelList = [
  { id: 0, descricao: "Conta corrente" },
  { id: 1, descricao: "Conta salário" },
]

export const TipoContestacaoDomainModelList = [
  { id: 1, descricao: "Falta registrada incorretamente" },
  { id: 2, descricao: "Falta compensada e não restituída" },
]

export const TipoFormacaoDomainModelList = [
  { id: 'Especialidade', descricao: "Especialidade" },
  { id: 'AreaAtuacao', descricao: "Área de Atuação" },
  { id: 'AnoAdicional', descricao: "Ano Adicional" },
  { id: 'AreaConcentracao', descricao: "Área de Concentração" },
]

export const TipoOcorrenciaDomainModelList = [
  { id: 1, descricao: "Falta sem justificativa" },
  { id: 2, descricao: "Compensação de falta" },
  { id: 3, descricao: "Falta por mudança de situação" },
  { id: 4, descricao: "Suspenso por mudança de situação" },
  { id: 5, descricao: "Período pré-matrícula" },
  { id: 6, descricao: "Acerto de bolsa" },
  { id: 7, descricao: "Compensação por contestação de pagamento" },
  { id: 8, descricao: "Compensação por prorrogação de licença maternidade" },
]

export const TipoPagamentoDomainModelList = [
  { id: 1, descricao: "SIAFI" },
  { id: 2, descricao: "SIAPE" },
]

export const TipoProgramaDomainModelList = [
  { id: 1, descricao: "Especialidade" },
  { id: 2, descricao: "Área de atuação" },
  { id: 3, descricao: "Ano adicional" },
]

export const TipoResidenciaDomainModelList = [
  { id: 1, descricao: "Médica" },
  { id: 2, descricao: "Área profissional da saúde" },
]

export const TipoSanguineoDomainModelList = [
  { id: 'AB+', descricao: "AB+", grupoSanguineo: "AB", fatorRH: "+" },
  { id: 'AB-', descricao: "AB-", grupoSanguineo: "AB", fatorRH: "-" },
  { id: 'A+', descricao: "A+", grupoSanguineo: "A", fatorRH: "+" },
  { id: 'A-', descricao: "A-", grupoSanguineo: "A", fatorRH: "-" },
  { id: 'B+', descricao: "B+", grupoSanguineo: "B", fatorRH: "+" },
  { id: 'B-', descricao: "B-", grupoSanguineo: "B", fatorRH: "-" },
  { id: 'O+', descricao: "O+", grupoSanguineo: "O", fatorRH: "+" },
  { id: 'O-', descricao: "O-", grupoSanguineo: "O", fatorRH: "-" },
]

export const TipoTransferenciaDomainModelList = [
  { id: 1, descricao: "Transferência para programas do Pró-Residências" },
  { id: 2, descricao: "Transferência de vaga não financiada pelo Pró-Residências para bolsa financiada pelo Pró-Residências" },
  { id: 3, descricao: "Transferência para vaga não financiada pelo Pró-Residências " },
]

export const TipoVagaDomainModelList = [
  { id: 1, descricao: "Novo programa" },
  { id: 2, descricao: "Ampliação de vagas" },
]

export const UFDomainModelList = [
  { id: '12', descricao: "AC", nome: "Acre", siglaRegiao: "N" },
  { id: '27', descricao: "AL", nome: "Alagoas", siglaRegiao: "NE" },
  { id: '16', descricao: "AP", nome: "Amapá", siglaRegiao: "N" },
  { id: '13', descricao: "AM", nome: "Amazonas", siglaRegiao: "N" },
  { id: '29', descricao: "BA", nome: "Bahia", siglaRegiao: "NE" },
  { id: '23', descricao: "CE", nome: "Ceará", siglaRegiao: "NE" },
  { id: '53', descricao: "DF", nome: "Distrito Federal", siglaRegiao: "CO" },
  { id: '32', descricao: "ES", nome: "Espírito Santo", siglaRegiao: "SE" },
  { id: '52', descricao: "GO", nome: "Goiás", siglaRegiao: "CO" },
  { id: '21', descricao: "MA", nome: "Maranhão", siglaRegiao: "NE" },
  { id: '51', descricao: "MT", nome: "Mato Grosso", siglaRegiao: "CO" },
  { id: '50', descricao: "MS", nome: "Mato Grosso do Sul", siglaRegiao: "CO" },
  { id: '31', descricao: "MG", nome: "Minas Gerais", siglaRegiao: "SE" },
  { id: '15', descricao: "PA", nome: "Pará", siglaRegiao: "N" },
  { id: '25', descricao: "PB", nome: "Paraíba", siglaRegiao: "NE" },
  { id: '41', descricao: "PR", nome: "Paraná", siglaRegiao: "S" },
  { id: '26', descricao: "PE", nome: "Pernambuco", siglaRegiao: "NE" },
  { id: '22', descricao: "PI", nome: "Piauí", siglaRegiao: "NE" },
  { id: '33', descricao: "RJ", nome: "Rio de Janeiro", siglaRegiao: "SE" },
  { id: '24', descricao: "RN", nome: "Rio Grande do Norte", siglaRegiao: "NE" },
  { id: '43', descricao: "RS", nome: "Rio Grande do Sul", siglaRegiao: "S" },
  { id: '11', descricao: "RO", nome: "Rondônia", siglaRegiao: "N" },
  { id: '14', descricao: "RR", nome: "Roraima", siglaRegiao: "N" },
  { id: '42', descricao: "SC", nome: "Santa Catarina", siglaRegiao: "S" },
  { id: '35', descricao: "SP", nome: "São Paulo", siglaRegiao: "SE" },
  { id: '28', descricao: "SE", nome: "Sergipe", siglaRegiao: "NE" },
  { id: '17', descricao: "TO", nome: "Tocantins", siglaRegiao: "N" },
]


// Added by 'EnumTypeScriptModelIdExtension' extension

export enum AnoAdicionalEnum {
  TRANSPLANTE_CORACAO = 1,
  TRANSPLANTE_FIGADO = 2,
  TRANSPLANTE_PANCREAS = 3,
  TRANSPLANTE_PULMAO = 4,
  TRANSPLANTE_RIM = 5,
  TRANSPLANTE_OSSOS = 6,
  TRANSPLANTE_PELE_ANEXOS = 7,
  TRANSPLANTE_CORNEA = 8,
  TRANSPLANTE_CRIANCAS_ADOLESCENTES = 9,
  CIRURGIA_GERAL_PROGRAMA_AVANCADO = 10,
  CIRURGIA_DO_TRAUMA = 11,
  TRANSPLANTE_CORACAO_CARDIOVASCULAR = 12,
  TRANSPLANTE_CORACAO_CARDIOLOGIA = 13,
  TRANSPLANTE_FIGADO_GASTROENTEROLOGIA = 14,
  TRANSPLANTE_FIGADO_APARELHO_DIGESTIVO = 15,
  TRANSPLANTE_PANCREAS_GASTROENTEROLOGIA = 16,
  TRANSPLANTE_PANCREAS_APARELHO_DIGESTIVO = 17,
  TRANSPLANTE_PANCREAS_ENDOCRINOLOGIA = 18,
  TRANSPLANTE_PULMAO_TORACICA = 19,
  TRANSPLANTE_PULMAO_PNEUMOLOGIA = 20,
  TRANSPLANTE_RIM_NEFROLOGIA = 21,
  TRANSPLANTE_RIM_UROLOGIA = 22,
  TRANSPLANTE_RIM_CIRURGIA_VASCULAR = 23,
  TRANSPLANTE_OSSOS_ORTOPEDIA = 24,
  TRANSPLANTE_PELE_ANEXOS_PLASTICA = 25,
  TRANSPLANTE_CORNEA_OFTALMOLOGIA = 26,
  TRANSPLANTE_CRIANCA_ADOLESCENTE_PEDIATRIA = 27,
  TRANSPLANTE_CRIANCA_ADOLESCENTE_CIRURGIA_PEDIATRICA = 28,
  CIRURGIA_GERAL_OPCIONAL = 29,
  CLINICA_MEDICA_OPCIONAL = 30,
  OBSTETRICIA_GINECOLOGIA_OPCIONAL = 31,
  PEDIATRIA_OPCIONAL = 32,
  NEFROLOGIA_ANO_OPCIONAL = 33,
  CARDIOLOGIA_ANO_OPCIONAL = 34,
  PROGRAMA_PRE_REQUISITO_AREA_CIRURGICA_BASICA = 35,
}

export enum AnoResidenciaEnum {
  AGUARDANDO_R1 = 0,
  R1 = 1,
  R2 = 2,
  R3 = 3,
  R4 = 4,
  R5 = 5,
  R6 = 6,
  R7 = 7,
  R8 = 8,
  R9 = 9,
  INTEGRALIZACAO = 10,
}

export enum AreaAtuacaoEnum {
  ADMINISTRACAO_EM_SAUDE = 1,
  ALERGIA_E_IMUNOLOGIA_PEDIATRICA = 2,
  ANGIORRADIOLOGIA_E_CIRURGIA_ENDOVASCULAR = 3,
  ATENDIMENTO_AO_QUEIMADO = 4,
  CARDIOLOGIA_PEDIATRICA = 5,
  CIRURGIA_BARIATRICA = 6,
  CIRURGIA_CRANIO_MAXILO_FACIAL = 7,
  CIRURGIA_DO_TRAUMA = 8,
  CIRURGIA_VIDEOLAPAROSCOPICA = 9,
  CITOPATOLOGIA = 10,
  DENSITOMETRIA_OSSEA = 11,
  DOR = 12,
  ECOCARDIOGRAFIA = 13,
  ECOGRAFIA_VASCULAR_COM_DOPPLER = 14,
  ELETROFISIOLOGIA_CLINICA_INVASIVA = 15,
  EMERGENCIA_PEDIATRICA = 16,
  ENDOCRINOLOGIA_PEDIATRICA = 17,
  ENDOSCOPIA_DIGESTIVA = 18,
  ENDOSCOPIA_GINECOLOGICA = 19,
  ENDOSCOPIA_RESPIRATORIA = 20,
  ERGOMETRIA = 21,
  ESTIMULACAO_CARDIACA_ELETRONICA_IMPLANTAVEL = 22,
  FONIATRIA = 23,
  GASTROENTEROLOGIA_PEDIATRICA = 24,
  HANSENOLOGIA = 25,
  HEMATOLOGIA_E_HEMOTERAPIA_PEDIATRICA = 26,
  HEMODINAMICA_E_CARDIOLOGIA_INTERVENCIONISTA = 27,
  HEPATOLOGIA = 28,
  INFECTOLOGIA_HOSPITALAR = 29,
  INFECTOLOGIA_PEDIATRICA = 30,
  MAMOGRAFIA = 31,
  MEDICINA_AEROESPACIAL = 32,
  MEDICINA_DO_ADOLESCENTE = 33,
  MEDICINA_DO_SONO = 34,
  MEDICINA_FETAL = 35,
  MEDICINA_INTENSIVA_PEDIATRICA = 36,
  MEDICINA_PALIATIVA = 37,
  MEDICINA_TROPICAL = 38,
  NEFROLOGIA_PEDIATRICA = 39,
  NEONATOLOGIA = 40,
  NEUROFISIOLOGIA_CLINICA = 41,
  NEUROLOGIA_PEDIATRICA = 42,
  NEURORRADIOLOGIA = 43,
  NUTRICAO_PARENTERAL_E_ENTERAL = 44,
  NUTRICAO_PARENTERAL_E_ENTERAL_PEDIATRICA = 45,
  NUTROLOGIA_PEDIATRICA = 46,
  ONCOLOGIA_PEDIATRICA = 47,
  PNEUMOLOGIA_PEDIATRICA = 48,
  PSICOGERIATRIA = 49,
  PSICOTERAPIA = 50,
  PSIQUIATRIA_DA_INFANCIA_E_ADOLESCENCIA = 51,
  PSIQUIATRIA_FORENSE = 52,
  RADIOLOGIA_INTERVENCIONISTA_E_ANGIORRADIOLOGIA_AREA = 53,
  REPRODUCAO_ASSISTIDA = 54,
  REUMATOLOGIA_PEDIATRICA = 55,
  SEXOLOGIA = 56,
  TOXICOLOGIA_MEDICA = 57,
  TRANSPLANTE_DE_MEDULA_OSSEA = 58,
  ULTRASSONOGRAFIA_EM_GINECOLOGIA_E_OBSTETRICIA = 59,
}

export enum AreaConcentracaoEnum {
  ATENCAO_BASICA_SAUDE_FAMILIA = 2,
  ATENCAO_ESPECIALIZADA_SAUDE = 3,
  SAUDE_BUCAL = 4,
  SAUDE_MENTAL = 5,
  SAUDE_IDOSO = 6,
  SAUDE_MULHER = 7,
  SAUDE_CRIANCA = 8,
  REABILITACAO_FISICA = 9,
  INTENSIVISMO = 10,
  URGENCIA_TRAUMA = 11,
  ALIMENTACAO_NUTRICAO = 12,
  ASSITENCIA_FARMACEUTICA = 13,
  VIGILANCIA_EM_SAUDE = 14,
  APOIO_DIAGNOSTICO_TERAPEUTICO = 15,
  ATENCAO_CANCER = 16,
  SAUDE_COLETIVA = 17,
  SAUDE_ANIMAL_AMBIENTAL = 18,
  ATENCAO_CLINICA_ESPECIALIZADA = 19,
  ATENCAO_CIRURGICA_ESPECIALIZADA = 20,
  FISICA_MEDICA = 21,
  ENFERMAGEM_OBSTETRICA = 22,
  SAUDE_FUNCIONAL_REABILITACAO = 23,
  CIRURGIA_TRAUMATOLOGIA_BUCOMAXILOFACIAL = 24,
  SAUDE_MATERNO_INFANTIL = 25,
  ATENCAO_CLINICA_ESPECIALIZADA_CARDIOPULMONAR = 26,
  ATENCAO_CLINICA_ESPECIALIZADA_INFECTOLOGIA = 27,
  ATENCAO_CLINICA_ESPECIALIZADA_NEUROLOGIA = 28,
  ATENCAO_CLINICA_ESPECIALIZADA_NEUROCIRURGIA = 29,
  ATENCAO_CLINICA_ESPECIALIZADA_ORTOPEDIA = 30,
  NUTRICAO_CLINICA = 31,
  REABILITACAO = 32,
  URGENCIA_EMERGENCIA = 33,
  NEUROLOGIA = 34,
  NEONATOLOGIA = 35,
  HEMATOLOGIA = 36,
}

export enum AreaEnum {
  MEDICINA = 1,
  GENETICA = 2,
  SAUDE_COLETIVA = 3,
}

export enum BancoEnum {
  BANCO_DO_BRASIL = '001',
  BANCO_CENTRAL_BRASIL = '002',
  BANCO_DA_AMAZONIA = '003',
  BANCO_DO_NORDESTE_DO_BRASIL = '004',
  BANCO_NACIONAL_DE_DESENVECONOMICO_E_SOCIAL = '007',
  CC_CREDICOAMO_CREDITO_RURAL_COOPERATIVA = '010',
  CREDIT_SUISSE_HEDGINGGRIFFO_CORRETORA = '011',
  BANCO_INBURSA_DE_INVESTIMENTOS = '012',
  STATE_STREET_BRASIL_BCO_COMERCIAL = '014',
  SICOOB_CREDITRAN = '016',
  BNY_MELLON_BANCO = '017',
  BANCO_TRICURY = '018',
  BANCO_DO_ESTADO_DO_ESPIRITO_SANTO = '021',
  BANCO_BANDEPE = '024',
  BANCO_ALFA = '025',
  BANCO_ITAU_CONSIGNADO = '029',
  BANCO_SANTANDER_BRASIL = '033',
  BANCO_BRADESCO_BBI = '036',
  BANCO_DO_ESTADO_DO_PARA = '037',
  BANCO_CARGILL = '040',
  BANCO_DO_ESTADO_DO_RIO_GRANDE_DO_SUL = '041',
  BANCO_DO_ESTADO_DE_SERGIPE = '047',
  CONFIDENCE_CORRETORA_DE_CAMBIO = '060',
  HIPERCARD_BANCO_MULTIPLO = '062',
  BANCO_BRADESCARD = '063',
  GOLDMAN_SACHS_DO_BRASIL_BANCO_MULTIPLO = '064',
  BANCO_ANDBANK_BRASIL = '065',
  BANCO_MORGAN_STANLEY_DEAN_WITTER = '066',
  BANCO_CREFISA = '069',
  BRBBANCO_DE_BRASILIA = '070',
  BANCO_JSAFRA = '074',
  BCO_ABN_AMRO = '075',
  KDB_DO_BRASIL = '076',
  BANCO_INTERMEDIUM = '077',
  BI_HAITONG_DO_BRASIL = '078',
  BANCO_ORIGINAL_DO_AGRONEGOCIO = '079',
  BT_ASSOCIADOS_CORRETORA_DE_CAMBIO_LTDA = '080',
  BANCO_SEGURO = '081',
  BANCO_TOPAZIO = '082',
  BANCO_DA_CHINA_BRASIL = '083',
  CC_UNIPRIME_NORTE_DO_PARANA = '084',
  CCC_AILOS = '085',
  BANCO_RANDON = '088',
  CREDISAN_COOPERATIVA_DE_CREDITO = '089',
  CC_UNICRED_CENTRAL_RS = '091',
  BRK_CREDITO_FINANCIAMENTO_E_INVEST = '092',
  POLOCRED_SOCIEDADE_CREDITO_MICROEMPREENDEDOR = '093',
  BANCO_FINAXIS = '094',
  TRAVELEX_BANCO_DE_CAMBIO = '095',
  BANCO_B3 = '096',
  CREDISIS_LTDA = '097',
  CREDIALIANCA_COOPERATIVA_CREDITO_RURAL = '098',
  UNIPRIME_CENTRAL = '099',
  PLANNER_CORRETORA_DE_VALORES = '100',
  DTVM_RENANSCENCA = '101',
  XP_INVESTIMENTOS_CCTVM = '102',
  CAIXA_ECONOMICA_FEDERAL = '104',
  LECCA_CREDITO_FINACIAMENTO_E_INVESTIMENTO = '105',
  BANCO_BOCOM_BBM = '107',
  PORTOCRED_CREDITO_FINANCIAMENTO_E_INV = '108',
  OLIVEIRA_TRUST_DIST_DE_TITULOS_E_VALORES = '111',
  MAGLIANO_CORRETORA_DE_CAMBIO_VALORES_MOB = '113',
  CENTRAL_COOPCRED_ESTADO_ESP_SANTO_CECOOP = '114',
  ADVANCED_CORRETORA_DE_CAMBIO_LTDA = '117',
  WESTERN_UNION_DO_BRASIL = '119',
  BANCO_RODOBENS = '120',
  BANCO_AGIBANK = '121',
  BANCO_BERJ = '122',
  BANCO_WOORI_BANK_DO_BRASIL = '124',
  BRASIL_PLURAL_BANCO_MULTIPLO = '125',
  BR_PARTNERS_BANCO_DE_INVESTIMENTO = '126',
  CODEPECORRETORA_DE_VALORES = '127',
  MSB_BANK_BANCO_DE_CAMBIO = '128',
  UBS_BRASIL_BANCO_DE_INVESTIMENTO = '129',
  CARUANA_SOCIEDADE_CREDITO_FINAC_E_INV = '130',
  TULLETT_PREBON_BRASILCORRETORA_VALORES = '131',
  ICBC_DO_BRASIL = '132',
  CRESOL_CONFEDERACAO = '133',
  BGC_LIQUIDEZ_DISTRTITULOS_E_VAL_MOBILIARIOS = '134',
  CC_UNICRED_DO_BRASIL = '136',
  SC_GET_MONEY = '138',
  INTENSA_SANPAOLO = '139',
  SC_EASYNVEST = '140',
  BROKER_BRASIL_CORRETORA_DE_CAMBIO_LTDA = '142',
  TREVISO_CORRETORA_DE_CAMBIO = '143',
  BEXSBANCO_DE_CAMBIO = '144',
  SC_LEVYCAM = '145',
  SC_GUITTA = '146',
  SCFI_FACTA_FINANCEIRA = '149',
  ICAP_DO_BRASIL_CORRETORA_DE_TTULOS_E_VALORES = '157',
  CASA_DO_CREDITO_SOCIEDADE_DE_CREDITO_AO = '159',
  COMMERZBANK_BRASIL_BANCO_MULTIPLO = '163',
  OL_BONSUCESSO_CONSIGNADO = '169',
  BRL_TRUST_DTVM = '173',
  SCFI_PERNAMBUCANAS = '174',
  GUIDE_INVESTIMENTOS_CORRETORA_DE_VALORES = '177',
  SC_CM_CAPITAL_MARKETS = '180',
  SOCRED_SOCDE_CRED_AO_MICROEMPE_EPP = '183',
  BANCO_ITAUBBA = '184',
  ATIVA_INVESTIMENTOS_SS_CORRETORA_DE_TITULOS = '188',
  HS_FINANCEIRA_CREDITO_FIN_E_INVEST = '189',
  COOP_DE_ECONOMIA_E_CREDITO_MUTUO_SERV_PUBL = '190',
  NOVA_FUTURA_CORRETORA_DE_TTULOS_E_VAL_MOB = '191',
  PARMETAL_DISTRIB_TIT_E_VALORES_MOBILIARIOS = '194',
  SC_FAIR = '196',
  STONE_PAGAMENTOS = '197',
  BRADESCO_CARTOES = '204',
  BTG_PACTUAL = '208',
  BANCO_ORIGINAL = '212',
  BANCO_ARBI = '213',
  BANCO_DIBENS = '214',
  BANCO_JOHN_DEERE = '217',
  BANCO_BS2 = '218',
  BANCO_CREDIT_AGRICOLE_BRASIL = '222',
  BANCO_FIBRA = '224',
  BANCO_CIFRA = '233',
  BANCO_BRADESCO = '237',
  BANCO_CLASSICO = '241',
  BANCO_MAXIMA = '243',
  BANCO_ABC_BRASIL = '246',
  BANCO_INVESTCRED_UNIBANCO = '249',
  BANCO_DE_CREDITO_E_VAREJO = '250',
  BEXS_CORRETORA_DE_CAMBIO = '253',
  PARANA_BANCO = '254',
  MONEYCORP_BANCO_DE_CMBIO = '259',
  NU_PAGAMENTOS = '260',
  BANCO_FATOR = '265',
  BANCO_CEDULA = '266',
  BARI_COMPANHIA_HIPOTECARIA = '268',
  BANCO_HSBC = '269',
  SAGITUR_CORRETORA_DE_CAMBIO_LTDA = '270',
  IB_CCTVM_LTDA = '271',
  AGK_CORRETORA_DE_CAMBIO = '272',
  COOP_DE_CRED_RURAL_DE_SAO_MIGUEL_DO_OESTE = '273',
  MONEY_PLUS_SCMEPP_LTDA = '274',
  SENFF_CRED_FINANC_E_INVESTIMENTO = '276',
  GENIAL_INVESTIMENTOS_CVM = '278',
  COOP_CRED_RURAL_DE_PRIMAVERA_DO_LESTE = '279',
  AVISTA_CREDITO_FINANC_E_INVESTIMENTO = '280',
  COOPERATIVA_DE_CREDITO_RURAL_COOPAVEL = '281',
  RB_CAPITAL_INVESTIM_DTVM_LTDA = '283',
  FRENTE_CORRETORA_DE_CAMBIO_LTDA = '285',
  COOPERATIVA_DE_CREDITO_RURAL_DE_OURO_SULCREDI = '286',
  CAROL_DTVM_LTDA = '288',
  DECYSEO_CORRETORA_DE_CAMBIO_LTDA = '289',
  PAGSEGURO_INTERNET = '290',
  BS2_DISTRIBUIDORA_TIT_VALORES_MOBILIARIOS = '292',
  LASTRO_RDV_DTVM_LTDA = '293',
  VISION_CORRETORA_DE_CAMBIO = '296',
  VIPS_CORRETORA_DE_CAMBIO_LTDA = '298',
  SOROCRED_CREDITO_FIN_E_INVESTIMENTO = '299',
  BANCO_DE_LA_NACION_ARGENTINA = '300',
  BPP_INSTITUICAO_DE_PAGAMENTO = '301',
  PORTOPAR_DTVM_LTDA = '306',
  TERRA_INVEST_DISTRIB_DE_TITVALORES_IMOBILI = '307',
  CAMBIONET_CORRETORA_DE_CAMBIO_LTDA = '309',
  VORTX_DISTRIB_TIT_E_VAL_MOBILIARIOS_LTDA = '310',
  HSCM_SCMEPP = '312',
  PI_DISTRIBUIDORA_DE_TIT_E_VAL_MOBILIARIOS = '315',
  BANCO_BMG = '318',
  OM_DISTRIBTITULOS_E_VALORES_MOBILIARIOS_LTDA = '319',
  CCB_BRASIL = '320',
  CREFAZ_SCMEPP_LTDA = '321',
  COOPERATIVA_DE_CREDITO_RURAL_DE_ABELARDO_LUZ = '322',
  MERCADOPAGOCOM_REPRESENTACOES_LTDA = '323',
  CARTOS_SOCIEDADE_DE_CRDITO_DIRETO = '324',
  ORAMA_DISTRIB_TITULOS_E_VALORES_MOBILIARIOS = '325',
  PARATI_CREDITO_FINANCIAMENTO_E_INVESTIM = '326',
  QI_SOCIEDADE_DE_CREDITO_DIRETO = '329',
  BANCO_BARI_DE_INVESTIMENTOS_E_FINANCIAMENTOS = '330',
  FRAM_CAPITAL_DTVM = '331',
  ACESSO_SOLUCOES_DE_PAGAMENTO = '332',
  BANCO_DIGIO = '335',
  BANCO_C6 = '336',
  SUPER_PAGAMENTOS_E_ADM_MEIOS_ELETRONICOS = '340',
  BANCO_ITAU_UNIBANCO = '341',
  CREDITAS_SOCIEDADE_DE_CREDITO_DIRETO = '342',
  FFA_SCMEPP_LTDA = '343',
  BANCO_XP = '348',
  AMAGGI_CREDITOFINANCIAMENTO_E_INVEST = '349',
  COOP_DE_CRED_RURAL_DE_PEQUENOS_AGRICULT = '350',
  TORO_CORRETORA_DE_TITULOS_E_VAL_MOBILIARIOS = '352',
  NECTON_INVESTIMENTOS_CVM = '354',
  OTIMO_SOCIEDADE_DE_CREDITO_DIRETO = '355',
  ZEMA_CREDITO_FINANC_E_INVESTIMENTO = '359',
  TRINUS_CAPITAL_DTVM = '360',
  CIELO = '362',
  SOCOPA_SOCIEDADE_CORRETORA_PAULISTA = '363',
  GERENCIANET_PAGAMENTOS_DO_BRASIL_LTDA = '364',
  SOLIDUS_CTVM = '365',
  BANCO_SOCIETE_GENERALE_BRASIL = '366',
  VITREO_DTVM = '367',
  BANCO_CSF = '368',
  BANCO_MIZUHO_DO_BRASIL = '370',
  WARREN_CORRETORA_DE_VALORES_MOBILIARIOS_E_CAM = '371',
  UPP_SOCIEDADE_EMPRSTIMO_ENTRE_PESSOAS = '373',
  REALIZE_CREDITO_FINANC_E_INVESTIMENTO = '374',
  BANCO_JPMORGAN = '376',
  MS_SOCIEDADE_DE_CREDITO_AO_MICROEMPREENDEDOR = '377',
  BBC_LEASING_ARRENDAMENTO_MERCANTIL = '378',
  COOPERFORTE_COOP_ECON_E_CRED_MUTUO_F_IF = '379',
  PICPAY_SERVICOS = '380',
  BANCO_MERCEDESBENZ_DO_BRASIL = '381',
  FIDUCIA_SOCIEDADE_DE_CREDITO = '382',
  BOLETOBANCRIOCOM_TECNOLOGIA_DE_PAGAMENTOS_L = '383',
  GLOBAL_FINANAS_SOCIEDADE_DE_CRDITO_AO_MICR = '384',
  NU_FINANCEIRA = '386',
  BANCO_TOYOTA_DO_BRASIL = '387',
  BANCO_MERCANTIL_DO_BRASIL = '389',
  BANCO_GM = '390',
  COOP_CREDITO_RURAL_DE_IBIAM_SULCREDIIBIAM = '391',
  BANCO_VOLKSWAGEN = '393',
  BRADESCO_FINANCIAMENTOS = '394',
  GOLD_DISTRIB_TTULOS_E_VALORES_MOBILIARIOS = '395',
  HUB_PAGAMENTOS = '396',
  LISTO_SOCIEDADE_DE_CREDITO_DIRETO = '397',
  IDEAL_DTVM = '398',
  KIRTON_BANK_BANCO_MULTIPLO = '399',
  COBUCCIO = '402',
  CORA_SOCIEDADE_DE_CRDITO_DIRETO = '403',
  SUMUP_SOCIEDADE_DE_CRDITO_DIRETO = '404',
  ACCREDITO_SOCIEDADE_DE_CRDITO_DIRETO = '406',
  INDIGO_INVESTIMENTOS_DTVM = '407',
  BONUSCRED_SOCIEDADE_DE_CREDITO_DIRETO = '408',
  PLANNER = '410',
  VIA_CERTA = '411',
  BANCO_CAPITAL = '412',
  BANCO_SAFRA = '422',
  BANCO_MUFG_BRASIL = '456',
  BANCO_SUMITOMO_MITSUI_BRASILEIRO = '464',
  BANCO_CAIXA_GERAL_BRASIL = '473',
  CITIBANK_NA = '477',
  BANCO_ITAUBANK = '479',
  DEUTSCHE_BANK_BANCO_ALEMAO = '487',
  JPMORGAN_CHASE_BANK = '488',
  ING_BANK_NV = '492',
  BANCO_DE_LA_REPUBLICA_ORIENTAL_DEL_URUGUAY = '494',
  BANCO_DE_LA_PROVINCIA_DE_BUENOS_AIRES = '495',
  BANCO_CREDIT_SUISSE_FIRST_BOSTON_GARANTIA_S = '505',
  SENSO_CORRETORA_CAMBIO_E_VALORES_MOBILIARIOS = '545',
  BANCO_LUSO_BRASILEIRO = '600',
  BANCO_INDUSTRIAL_DO_BRASIL = '604',
  BANCO_VR = '610',
  BANCO_PAULISTA = '611',
  BANCO_GUANABARA = '612',
  OMNI_BANCO = '613',
  BANCO_PAN = '623',
  BANCO_FICSA = '626',
  BANCO_SMARTBANK = '630',
  BANCO_RENDIMENTO = '633',
  BANCO_TRIANGULO = '634',
  BANCO_SOFISA = '637',
  BANCO_PINE = '643',
  BANCO_ITAU_UNIBANCOHOLDING = '652',
  BANCO_INDUSVAL = '653',
  BANCO_DIGIMAIS = '654',
  BANCO_VOTORANTIM = '655',
  BANCO_DAYCOVAL = '707',
  BM_OURINVEST = '712',
  BANCO_MORADA = '738',
  CETELEM = '739',
  BANCO_RIBEIRAO_PRETO = '741',
  BANCO_SEMEAR = '743',
  BANCO_CITIBANK = '745',
  BANCO_MODAL = '746',
  BANCO_RABOBANK_INTERNATIONAL_BRASIL = '747',
  BANCO_COOPERATIVO_SICREDI = '748',
  SCOTIABANK_BRASIL_BANCO_MULTIPLO = '751',
  BANCO_BNP_PARIBAS_BRASIL = '752',
  NBC_BANK_BRASIL = '753',
  BANCO_SISTEMA = '754',
  BANCO_MERRILL_LYNCH = '755',
  BANCO_COOPERATIVO_DO_BRASIL = '756',
  BANCO_KEB_HANA_DO_BRASIL = '757',
}

export enum CategoriaProfissionalEnum {
  BIOMEDICINA = 1,
  BIOLOGIA = 2,
  EDUCACAO_FISICA = 3,
  ENFERMAGEM = 4,
  FARMACIA = 5,
  FISIOTERAPIA = 6,
  FONOAUDIOLOGIA = 7,
  MEDICINA = 8,
  MEDICINA_VETERINARIA = 9,
  NUTRICAO = 10,
  ODONTOLOGIA = 11,
  PSICOLOGIA = 12,
  SERVICO_SOCIAL = 13,
  TERAPIA_OCUPACIONAL = 14,
  SAUDE_COLETIVA = 15,
  FISICA_MEDICA = 16,
  FISICA = 17,
  CIENCIA_E_TECNOLOGIA = 18,
  MATEMATICA = 19,
  HISTORIA = 20,
  ENGENHARIA_AMBIENTAL = 21,
  PEDAGOGIA = 22,
  ANTROPOLOGIA = 23,
  GESTAO_AMBIENTAL = 24,
}

export enum ConselhoProfissionalEnum {
  BIOLOGIA = 1,
  BIOMEDICINA = 2,
  EDUCACAO_FISICA = 3,
  ENFERMAGEM = 4,
  FARMACIA = 5,
  FISIOTERAPIA = 6,
  FONOAUDIOLOGIA = 7,
  MEDICINA = 8,
  VETERINARIA = 9,
  NUTRICIONISTA = 10,
  PSICOLOGIA = 11,
  ODONTOLOGIA = 12,
  SERVICO_SOCIAL = 13,
  RADIOLOGIA = 14,
  NAO_SE_APLICA = 999,
}

export enum DocumentoComprobatorioEnum {
  ATESTADO_MEDICO = 1,
  OFICIO_INSTITUICAO = 2,
  CERTIDAO_NASCIMENTO = 3,
  DECLARACAO_RESIDENTE = 4,
  TERMO_DESISTENCIA = 5,
  PARECER_CNRM = 6,
  REQUERIMENTO_RESIDENTE = 7,
  OFICIO_INSTITUICAO_PERIODO = 8,
  OFICIO_INSTITUICAO_JUSTIFICATIVA_PERIODO = 9,
  DOCUMENTO_COMPROBATORIO = 10,
  OFICIO_COMISSAO_CONCLUSAO_RESIDENCIA = 11,
}

export enum DocumentoTransferenciaEnum {
  OFICIO_COMISSAO_ORIGEM = 1,
  OFICIO_COMISSAO_DESTINO = 2,
  PARECER_CNRM_CNRMS_TRANSFERENCIA = 3,
  PARECER_CNRM_CNRMS_DESCREDENCIAMENTO = 4,
  PARECER_CEREM_CODEMU_DESTINO = 5,
  COPIA_DECISAO_JUDICIAL = 6,
  INFORMACAO_DATA_FIM_ATIVIDADES = 7,
  OFICIO_INFORMACAO_TRANSFERENCIA_RESIDENTE = 8,
  TERMO_ANUENCIA = 9,
  CONFIRMACAO_MATRICULA_RESIDENTE = 10,
}

export enum DuracaoProgramaEnum {
  ANO_1 = 1,
  ANO_2 = 2,
  ANO_3 = 3,
  ANO_4 = 4,
  ANO_5 = 5,
}

export enum EscolaridadeEnum {
  SUPERIOR_COMPLETO = '08',
  ESPECIALIZACAO_RESIDENCIA = '09',
  MESTRADO = '10',
  DOUTORADO = '11',
}

export enum EspecialidadeEnum {
  ACUPUNTURA = 1,
  ALERGIA_E_IMUNOLOGIA = 2,
  ANESTESIOLOGIA = 3,
  ANGIOLOGIA = 4,
  CARDIOLOGIA = 5,
  CIRURGIA_CARDIOVASCULAR = 6,
  CIRURGIA_DA_MAO = 7,
  CIRURGIA_DA_CABECA_E_PESCOCO = 8,
  CIRURGIA_DO_APARELHO_DIGESTIVO = 9,
  CIRURGIA_GERAL = 10,
  CIRURGIA_ONCOLOGICA = 11,
  CIRURGIA_PEDIATRICA = 12,
  CIRURGIA_PLASTICA = 13,
  CIRURGIA_TORACICA = 14,
  CIRURGIA_VASCULAR = 15,
  CLINICA_MEDICA = 16,
  COLOPROCTOLOGIA = 17,
  DERMATOLOGIA = 18,
  ENDOCRINOLOGIA_E_METABOLOGIA = 19,
  ENDOSCOPIA = 20,
  GASTROENTEROLOGIA = 21,
  GENETICA_MEDICA = 22,
  GERIATRIA = 23,
  GINECOLOGIA_E_OBSTETRICIA = 24,
  HEMATOLOGIA_E_HEMOTERAPIA = 25,
  HOMEOPATIA = 26,
  INFECTOLOGIA = 27,
  MASTOLOGIA = 28,
  MEDICINA_DE_EMERGENCIA = 29,
  MEDICINA_DE_FAMILIA_E_COMUNIDADE = 30,
  MEDICINA_DO_TRABALHO = 31,
  MEDICINA_DE_TRAFEGO = 32,
  MEDICINA_ESPORTIVA = 33,
  MEDICINA_FISICA_E_REABILITACAO = 34,
  MEDICINA_INTENSIVA = 35,
  MEDICINA_LEGAL_E_PERICIA_MEDICA = 36,
  MEDICINA_NUCLEAR = 37,
  MEDICINA_PREVENTIVA_E_SOCIAL = 38,
  NEFROLOGIA = 39,
  NEUROCIRURGIA = 40,
  NEUROLOGIA = 41,
  NUTROLOGIA = 42,
  OFTALMOLOGIA = 43,
  ONCOLOGIA_CLINICA = 44,
  ORTOPEDIA_E_TRAUMATOLOGIA = 45,
  OTORRINOLARINGOLOGIA = 46,
  PATOLOGIA = 47,
  PATOLOGIA_CLINICA_MEDICINA_LABORATORIAL = 48,
  PEDIATRIA = 49,
  PNEUMOLOGIA = 50,
  PSIQUIATRIA = 51,
  RADIOLOGIA_E_DIAGNOSTICO_POR_IMAGEM = 52,
  ULTRASSONOGRAFIA_GERAL = 53,
  RADIOLOGIA_INTERVENCIONISTA_E_ANGIORRADIOLOGIA_ESPECIALIDADE = 54,
  RADIOTERAPIA = 55,
  REUMATOLOGIA = 56,
  UROLOGIA = 57,
}

export enum EstadoCivilEnum {
  CASADO = '01',
  SOLTEIRO = '02',
  DIVORCIADO_SEPARADO = '03',
  VIUVO = '05',
  UNIAO_ESTAVEL = '06',
}

export enum GrandeAreaEnum {
  CIENCIAS_SAUDE = 1,
  CIENCIAS_BIOLOGICAS = 2,
}

export enum GrauSatisfacaoEnum {
  MUITO_INSATISFEITO = 1,
  INSATISFEITO = 2,
  NEUTRO = 3,
  SATISFEITO = 4,
  MUITO_SATISFEITO = 5,
}

export enum ModalidadeProgramaEnum {
  UNIPROFISSIONAL = 1,
  MULTIPROFISSIONAL = 2,
}

export enum NacionalidadeEnum {
  BRASILEIRA = 1,
  ESTRANGEIRA = 4,
}

export enum OrgaoEmissorRGEnum {
  SSP = '1',
  MINISTERIOS_MILITARES = '2',
  MINISTERIOS_AERONAUTICA = '3',
  MINISTERIO_EXERCITO = '4',
  MINISTERIO_MARINHA = '5',
  POLICIA_FEDERAL = '6',
  CART_IDENT_CLASSISTA = '7',
  CONSELHO_REG_ADMINISTRACAO = '8',
  CONSELHO_REG_ASSIST_SOCIAL = '9',
  CONSELHO_REG_BIBLIOTECONOMIA = '10',
  CONSELHO_REG_ENFERMAGEM = '11',
  NAO_IDENTIFICADO = '12',
  DOCUMENTO_ESTRANGEIRO = '13',
}

export enum OrigemTransferenciaEnum {
  SOLICITACAO_RESIDENTE = 1,
  MANDADO_JUDICIAL = 2,
  DESCREDENCIAMENTO_PROGRAMA = 3,
}

export enum PeriodoAvaliacaoEnum {
  NAO_INICIADO = 1,
  EM_AVALIACAO = 2,
  ENCERRADO = 3,
}

export enum PeriodoRecursoEnum {
  NAO_INICIADO = 1,
  SOLICITACAO_RECURSO = 2,
  AVALIACAO_RECURSO = 3,
  ENCERRADO = 4,
}

export enum RacaCorEnum {
  AMARELA = '03',
  BRANCA = '01',
  INDIGENA = '05',
  PARDA = '04',
  PRETA = '02',
  SEM_INFORMACAO = '99',
}

export enum RegiaoEnum {
  NORTE = '1',
  NORDESTE = '2',
  SUDESTE = '3',
  SUL = '4',
  CENTROOESTE = '5',
}

export enum ResultadoAvaliacaoEnum {
  HOMOLOGADA = 3,
  NAO_HOMOLOGADA = 4,
  EM_AVALIACAO = 5,
}

export enum ResultadoRecursoEnum {
  HOMOLOGADO = 1,
  NAO_HOMOLOGADO = 2,
}

export enum RoleEnum {
  ROLE_DEGTS = 1,
  ROLE_COORDENADOR = 2,
  ROLE_RESIDENTE = 3,
  ROLE_SUPERVISOR = 4,
  ROLE_FINANCEIRO = 5,
  ROLE_DEV = 6,
  ROLE_TRANSFERENCIA = 7,
  ROLE_ADMINISTRADOR = 8,
}

export enum SecretariaConveniadaEnum {
  MUNICIPAL = 1,
  ESTADUAL = 2,
  DISTRITO_FEDERAL = 3,
}

export enum SexoEnum {
  FEMININO = 'F',
  MASCULINO = 'M',
}

export enum SituacaoAuxilioMoradiaEnum {
  AGUARDANDO_AVALIACAO = 1,
  DESISTENTE = 2,
  AGUARDANDO_REAVALIACAO = 3,
  SUSPENSO = 4,
  REPROVADO = 5,
  APROVADO = 6,
}

export enum SituacaoContestacaoEnum {
  PENDENTE = 1,
  APROVADA = 2,
  REPROVADA = 3,
}

export enum SituacaoEditalEnum {
  ABERTO = 1,
  ENCERRADO = 2,
  AGUARDANDO_INICIO = 3,
}

export enum SituacaoFolhaEnum {
  ABERTA = 1,
  FECHADA = 2,
}

export enum SituacaoInscricaoEnum {
  AVALIACAO_PENDENTE = 1,
  EM_RASCUNHO = 2,
  HOMOLOGADA = 3,
  NAO_HOMOLOGADA = 4,
  EM_AVALIACAO = 5,
  EM_RECURSO = 6,
  NAO_CONCLUIDA = 7,
}

export enum SituacaoMatriculaEnum {
  AGUARDANDO_CADASTRO = 1,
  MATRICULADO = 2,
  MATRICULA_CANCELADA = 3,
  DESISTENTE_DESLIGADO = 4,
  ATESTADO_MEDICO_MAIS_QUINZE_DIAS = 5,
  LICENCA_MATERNIDADE = 6,
  TRANCAMENTO = 7,
  RESIDENCIA_CONCLUIDA = 8,
  TRANSFERIDO = 9,
  TRANCAMENTO_MILITAR = 10,
  PENDENTE_CONCLUSAO_TCC = 11,
  FERIAS = 12,
  SUSPENSO = 13,
  PRORROGACAO_LICENCA = 14,
  CADASTRO_INCOMPLETO = 15,
}

export enum SituacaoPagamentoEnum {
  AGUARDANDO = 1,
  ENCAMINHADO = 2,
  PAGO = 3,
  ERRO = 4,
  SUSPENSO = 5,
  DADOS_INCOMPLETOS = 8,
  DADOS_ATUALIZADOS = 9,
}

export enum SituacaoTransferenciaEnum {
  AGUARDANDO_ANUENCIA = 1,
  AGUARDANDO_PARECER = 2,
  ANUENCIA_NEGADA = 3,
  AGUARDANDO_CONFIRMACAO = 4,
  TRANSFERENCIA_CONCLUIDA = 5,
  TRANSFERENCIA_NEGADA = 6,
  AGUARDANDO_SUBSTITUICAO_ANUENCIA = 7,
  AGUARDANDO_SUBSTITUICAO_CONFIRMACAO = 8,
}

export enum SubAreaEnum {
  CLINICA_MEDICA = 1,
  CIRURGIA = 2,
  GENETICA_HUMANA_MEDICA = 3,
  MEDICINA_LEGAL_DEONTOLOGIA = 4,
  PSIQUIATRIA = 5,
  GESTAO_SAUDE = 6,
}

export enum TipoComissaoEnum {
  COREME = 1,
  COREMU = 2,
}

export enum TipoContaEnum {
  CONTA_CORRENTE = 0,
  CONTA_SALARIO = 1,
}

export enum TipoContestacaoEnum {
  FALTA_REGISTRADA_INCORRETAMENTE = 1,
  FALTA_COMPENSADA_NAO_RESTITUIDA = 2,
}

export enum TipoFormacaoEnum {
  Especialidade = 'Especialidade',
  AreaAtuacao = 'AreaAtuacao',
  AnoAdicional = 'AnoAdicional',
  AreaConcentracao = 'AreaConcentracao',
}

export enum TipoOcorrenciaEnum {
  FALTA = 1,
  COMPENSACAO_FALTA = 2,
  FALTA_MUDANCA_SITUACAO = 3,
  SUSPENSO_MUDANCA_SITUACAO = 4,
  PERIODO_PRE_MATRICULA = 5,
  ACERTO_BOLSA = 6,
  COMPENSACAO_CONTESTACAO_PAGAMENTO = 7,
  COMPENSACAO_PRORROGACAO_LICENCA_MATERNIDADE = 8,
}

export enum TipoPagamentoEnum {
  SIAFI = 1,
  SIAPE = 2,
}

export enum TipoProgramaEnum {
  ESPECIALIDADE = 1,
  AREA_ATUACAO = 2,
  ANO_ADICIONAL = 3,
}

export enum TipoResidenciaEnum {
  MEDICA = 1,
  AREA_PROFISSIONAL_SAUDE = 2,
}

export enum TipoSanguineoEnum {
  AB_POS = 'AB+',
  AB_NEG = 'AB-',
  A_POS = 'A+',
  A_NEG = 'A-',
  B_POS = 'B+',
  B_NEG = 'B-',
  O_POS = 'O+',
  O_NEG = 'O-',
}

export enum TipoTransferenciaEnum {
  INTERNA = 1,
  EXTERNA_ENTRADA = 2,
  EXTERNA_SAIDA = 3,
}

export enum TipoVagaEnum {
  NOVO_PROGRAMA = 1,
  AMPLIACAO_VAGA = 2,
}

export enum UFEnum {
  ACRE = '12',
  ALAGOAS = '27',
  AMAPA = '16',
  AMAZONAS = '13',
  BAHIA = '29',
  CEARA = '23',
  DISTRITO_FEDERAL = '53',
  ESPIRITO_SANTO = '32',
  GOIAS = '52',
  MARANHAO = '21',
  MATO_GROSSO = '51',
  MATO_GROSSO_DO_SUL = '50',
  MINAS_GERAIS = '31',
  PARA = '15',
  PARAIBA = '25',
  PARANA = '41',
  PERNAMBUCO = '26',
  PIAUI = '22',
  RIO_DE_JANEIRO = '33',
  RIO_GRANDE_DO_NORTE = '24',
  RIO_GRANDE_DO_SUL = '43',
  RONDONIA = '11',
  RORAIMA = '14',
  SANTA_CATARINA = '42',
  SAO_PAULO = '35',
  SERGIPE = '28',
  TOCANTINS = '17',
}
